import Vue from 'vue'
import Router from 'vue-router'
import dynamicRouteComponent from './useComponent.js'

const ErrorPage = () => import(/* webpackChunkName: "page-error" */ '../views/error/Error.vue')
const DemoPage = () => import(/* webpackChunkName: "page-login" */ '../views/test/demo/Page.vue')
const LoginPage = () => import(/* webpackChunkName: "page-login" */ '../views/login/LoginPage.vue')
const HomePage = () => import(/* webpackChunkName: "page-home" */ '../views/home/HomePage.vue')
const HomeStatistics = () => import(/* webpackChunkName: "page-home" */ '../views/home/HomeStatistics.vue')
const HomeConsole = () => import(/* webpackChunkName: "page-home" */ '../views/home/HomeConsole.vue')
const HelpPage = () => import(/* webpackChunkName: "page-home" */ '../views/help/HelpPage.vue')
const FaqPage = () => import(/* webpackChunkName: "page-faq" */ '../views/faq/FaqPage.vue')
const CustomerInfoPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/customer/CustomerInfoPage.vue')
const CustomerPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/customer/CustomerPage.vue')
const CompanyPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/company/CompanyPage.vue')

// 车辆租赁管理
const VehicleArchivePage = () => import(/* webpackChunkName: "page-carRental" */ '../views/carRental/VehicleArchivePage.vue')
const VehicleDeliveryRecordPage = () => import(/* webpackChunkName: "page-carRental" */ '../views/carRental/VehicleDeliveryRecordPage.vue')
const VehicleMaintenanceRecordPage = () => import(/* webpackChunkName: "page-carRental" */ '../views/carRental/VehicleMaintenanceRecordPage.vue')
const VehicleDailyRecordPage = () => import(/* webpackChunkName: "page-carRental" */ '../views/carRental/VehicleDailyRecordPage.vue')
const RentalRateStatisticsPage = () => import(/* webpackChunkName: "page-carRental" */ '../views/carRental/RentalRateStatisticsPage.vue')
const RentalVehicleFaultReportPage = () => import(/* webpackChunkName: "page-carRental" */ '../views/vehicleFaultReport/RentalVehicleFaultReportPage.vue')
const CompanyConfPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/companyConfig/CompanyConfigPage.vue')
const BasicCompanyConfigPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/companyConfig/BasicCompanyConfigPage.vue')
const UpdatePasswordPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/customer/UpdatePasswordPage.vue')
const SwitchAccount = () => import(/* webpackChunkName: "SwitchAccount" */ '../views/basic/customer/SwitchAccount.vue')
const UpdateCustomerInfoPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/customer/UpdateCustomerInfoPage.vue')
const CountAreaCustomerRegisteredPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/customer/CountAreaCustomerRegisteredPage.vue')
const ServerInfoPage = () => import(/* webpackChunkName: "page-monitor" */ '../views/monitor/server/ServerInfoPage.vue')
const CustomerPageForCompany = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/customer/CustomerPageForCompany.vue')

const OrganizationPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/organization/OrganizationPage.vue')
const ActorPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/actor/ActorPage.vue')
const CompanyActorPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/companyActor/ActorPage.vue')
const ActorOrderPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/actorOrder/ActorOrderPage.vue')
const ActorShopInfoPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/actorShopInfo/ActorShopInfoPage.vue')
const PurviewPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/puview/PurviewPage.vue')
const AppPuviewPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/appPuview/AppPuviewPage.vue')
const BasicAppPuviewPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/appPuview/BasicAppPurviewPage.vue')
const AppToShopPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/appPuview/AppToShopPage.vue')
const AppToCommunityPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/appPuview/AppToCommunityPage.vue')
const AppLabelPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/appLabel/AppLabelPage.vue')

// 供应链管理
const SupplyChainManagementPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/supplyChainManagement/SupplyChainManagementPage.vue')

const DocumentPage = () => import(/* webpackChunkName: "page-system" */ '../views/system/document/DocumentPage.vue')

const ConfigPage = () => import(/* webpackChunkName: "page-system" */ '../views/system/config/ConfigPage.vue')
const I18nPage = () => import(/* webpackChunkName: "page-system" */ '../views/system/i18n/I18nPage.vue')
const KeybookPage = () => import(/* webpackChunkName: "page-system" */ '../views/system/keybook/KeybookPage.vue')
const GeneratorPage = () => import(/* webpackChunkName: "page-system" */ '../views/system/generator/GeneratorPage.vue')
const SmsSendLogPage = () => import(/* webpackChunkName: "page-system" */ '../views/sms/smsSendLog/SysSmsSendLogPage.vue')
const redisPage = () => import(/* webpackChunkName: "page-system" */ '../views/system/redisview/RedisPage.vue')
const ConfigItemPage = () => import(/* webpackChunkName: "page-system" */ '../views/system/config/ConfigItemPage.vue')

const PositionPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/position/PositionPage.vue')

const CityPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/city/CityPage.vue')
const HouseCustomerPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/houseCustomer/HouseCustomerPage.vue')
const HouseCustomerDeletePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/houseCustomer/HouseCustomerDeletePage.vue')
const VisitorPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/visitor/VisitorPage.vue')

const BuildingPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/building/BuildingPage.vue')
const LandMarkPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/landmarkBuilding/PropertyLandmarkBuildingPage.vue')
const BuildingUnitPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/buildingUnit/BuildingUnitPage.vue')
const CommunityPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/community/CommunityPage.vue')
const EvaluatePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/evaluate/EvaluatePage.vue')
const HousePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/house/HousePage.vue')
const HouseFilePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/house/HouseFilePage.vue')
const HouseVisitPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/houseVisit/HouseVisitPage.vue')
const HousePaymentPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/housePayment/HousePaymentPage.vue')
const HousePaymentGroupPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/housePayment/HousePaymentGroupPage.vue')
const StatisticsForHousePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/housePayment/HousePaymentStatisticsForHousePage.vue')
const MessagePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/message/MessagePage.vue')
const ShopInfoNoticePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/notice/NoticePage.vue')
const ParkActivityPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkActivity/ParkActivityPage.vue')
const ParkActivityRulePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkActivityRule/AdvertisementParkActivityRulePage.vue')
const NeighboursPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/neighbours/NeighboursPage.vue')
const NoticeLogPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/noticeLog/NoticeLogPage.vue')
const NoticeTypePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/noticeType/NoticeTypePage.vue')
const NoticeInformPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/noticeInform/NoticeInformPage.vue')
const CommentInformPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/noticeInform/CommentInformPage.vue')
const ReplyInformPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/noticeInform/ReplyInformPage.vue')
//物业缴费
const ReceiptPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/receipt/ReceiptPage.vue')
const ReceiptDetailPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/receiptDetail/ReceiptDetailPage.vue')
const ReceiptDetailStatisticsByPayment = () => import(/* webpackChunkName: "page-property" */ '../views/property/receiptDetail/ReceiptDetailStatisticsByPayment.vue')
const ReceiptDetailStatisticsByMonth = () => import(/* webpackChunkName: "page-property" */ '../views/property/receiptDetail/ReceiptDetailStatisticsByMonth.vue')
const ReceiptDetailDailyStatisticsByPayment = () => import(/* webpackChunkName: "page-property" */ '../views/property/receiptDetailDaily/ReceiptDetailDailyStatisticsByPayment.vue')
const ReceiptRefundPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/receiptRefund/ReceiptRefundPage.vue')
const ReceiptRefundDetailPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/receiptRefundDetail/ReceiptRefundDetailPage.vue')
//物业报修
const RepairPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repair/RepairPage.vue')
const RepairStatisticsPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairStatistics/RepairStatisticsPage.vue')
const RepairStatisticsForType = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairStatistics/RepairStatisticsForType.vue')
const RepairStatisticsForSource = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairStatistics/RepairStatisticsForSource.vue')
const RepairStatisticsForResult = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairStatistics/RepairStatisticsForResult.vue')
const RepairStatisticsForPerson = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairStatistics/RepairStatisticsForPerson.vue')
const RepairStatisticsForCommunity = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairStatistics/RepairStatisticsForCommunity.vue')
const RepairUserPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairUser/RepairUserPage.vue')
const RepairImgPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairImg/RepairImgPage.vue')
const RepairLogPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairLog/RepairLogPage.vue')
const RepairEngineerPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairEngineer/RepairEngineerPage.vue')
const RepairTypePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairType/RepairTypePage.vue')
const RepairTypeConfigPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repairTypeConfig/RepairTypeConfigPage.vue')
const BroadcastingPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/broadcasting/BroadcastingPage.vue')
const BroadcastingPageForShop = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/broadcasting/BroadcastingPageForShop.vue')
const CartPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/cart/CartPage.vue')
const FaceRecognitionPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/faceRecognition/FaceRecognitionPage.vue')
const CarNoPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/carNo/CarNoPage.vue')
const CarNoCZPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/carNo/CarNoCZPage.vue')
const CarNoXKPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/carNo/CarNoXKPage.vue')
const CarVisitorPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/carVisitor/PropertyCarVisitorPage.vue')
const CarNovelPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/carNovel/PropertyCarNovelPage.vue')
const NotificationTemplatePositionPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/notificationTemplatePosition/NotificationTemplatePositionPage.vue')
const WorkRecordTypePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/workRecordType/WorkRecordTypePage.vue')
const WorkRecordPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/workRecord/WorkRecordPage.vue')
//车位相关
const ParkingSpacePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkSpace/ParkingSpacePage.vue')
const ParkingCustomerPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkingCustomer/ParkingCustomerPage.vue')
const ParkingGroupPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkingGroup/ParkingGroupPage.vue')
const ParkingPresalesPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkingPresales/ParkingPresalesPage.vue')
const ParkingPresalesSpacePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkingPresales/ParkingPresalesSpacePage.vue')
const ParkingChannelPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkingChannel/ParkingChannelPage.vue')

// 车牌相关
const VehicleNoPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/vehicleNo/VehicleNoPage.vue')
const VehicleNoOfficePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/vehicleNo/VehicleNoOfficePage.vue')

const ShopOrderPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/order/OrderPage.vue')
const CommunityOrderPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/order/CommunityOrderPage.vue')
const OrderDetailPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/orderDetail/OrderDetailPage.vue')
const OrderLogPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/orderLog/OrderLogPage.vue')
const SelfMentionOrderPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/order/SelfMentionOrderPage.vue')

const AdvertisementTwinklePage = () => import(/* webpackChunkName: "page-twinkle" */ '../views/twinkle/AdvertisementTwinklePage.vue')
const AdvertisementPopupPage = () => import(/* webpackChunkName: "page-twinkle" */ '../views/popup/AdvertisementPopupPage.vue')
const BroadcastingPlatformPage = () => import(/* webpackChunkName: "page-twinkle" */ '../views/basic/broadcastingPlatform/AdvertisementBroadcastingPlatformPage.vue')
//商品模块
const ProductPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/product/ProductPage.vue')
const IntegralProductPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/integralProduct/ProductPage.vue')
const VipProductPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/product/VipProductPage.vue')
const productPreSalePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/product/ProductPreSalePage.vue')
const DirectSellingPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/product/directSelling/DirectSellingPage.vue')
const ProductTotalSaleStatisticsPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/product/ProductTotalSaleStatisticsPage.vue')

const ProductHitStatisticPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productHitStatistic/ProductHitStatisticPage.vue')
const ProductImgPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productImg/ProductImgPage.vue')
const ProductInfoPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productInfo/ProductInfoPage.vue')
const ProductInfoImgPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productInfoImg/ProductInfoImgPage.vue')
const ProductPricePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productPrice/ProductPricePage.vue')
const ProductPromotionPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productPromotion/ProductPromotionPage.vue')
const ProductStorePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productStore/ProductStorePage.vue')
const ProductTypePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productType/ProductTypePage.vue')
const ProductIntegralTypePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productIntegralType/ProductTypePage.vue')
const PromotionPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/promotion/PromotionPage.vue')
const DeletePromotionPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/promotion/DeletePromotionPage.vue')
const PromotionCommunity = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/promotionCommunity/PromotionCommunityPage.vue')
const ReturnApplyPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/returnApply/ReturnApplyPage.vue')
const RefundOrderPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/refundOrder/RefundOrderPage.vue')
const CouponPage = () => import(/* webpackChunkName: "page-treasury" */ '../views/treasury/coupon/CouponPage.vue')
const TreasuryCouponPackPage = () => import(/* webpackChunkName: "page-treasury" */ '../views/treasury/couponPack/TreasuryCouponPackPage.vue')
const CouponCustomerPage = () => import(/* webpackChunkName: "page-treasury" */ '../views/treasury/couponCustomer/CouponCustomerPage.vue')
const AuditCouponCustomerPage = () => import(/* webpackChunkName: "page-treasury" */ '../views/treasury/couponCustomer/AuditCouponCustomerPage.vue')
const CouponPackCustomerPage = () => import(/* webpackChunkName: "page-treasury" */ '../views/treasury/couponPackCustomer/TreasuryCouponPackCustomerPage.vue')
const HouseTypePage = () => import(/* webpackChunkName: "page-decoration" */ '../views/decoration/houseType/HouseTypePage.vue')
const CompanyCommunityPage = () => import(/* webpackChunkName: "page-decoration" */ '../views/decoration/companyCommunity/CompanyCommunityPage.vue')
const EnrollPage = () => import(/* webpackChunkName: "page-decoration" */ '../views/decoration/enroll/EnrollPage.vue')
const CompanyInformationPage = () => import(/* webpackChunkName: "page-decoration" */ '../views/decoration/companyInformation/CompanyInformationPage.vue')
const CompanyInformationListPage = () => import(/* webpackChunkName: "page-decoration" */ '../views/decoration/companyInformationList/CompanyInformationListPage.vue')
const EnterprisePhonePage = () => import(/* webpackChunkName: "page-decoration" */ '../views/decoration/enterprisePhone/EnterprisePhonePage.vue')
const PhoneLogPage = () => import(/* webpackChunkName: "page-decoration" */ '../views/decoration/phoneLog/PhoneLogPage.vue')
const PayTypePage = () => import(/* webpackChunkName: "page-pay" */ '../views/pay/payType/PayTypePage.vue')
const SoftwarePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/software/SoftwarePage.vue')
const CompanyUserPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/companyUser/CompanyUserPage.vue')
const CompanyUserCommunityPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/companyUserCommunity/CompanyUserCommunityPage.vue')
const HousePayCountPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/housePayCount/HousePayCountPage.vue')
const ShopBillPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/bill/ShopBillPage.vue')
const ShopBillSuccessPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/bill/ShopBillSuccessPage.vue')
const ShopBillFailPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/bill/ShopBillFailPage.vue')
const SettlementPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/settlement/SettlementPage.vue')
const SettlementPageStatusOne = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/settlement/SettlementPageStatusOne.vue')
const SettlementPageStatusTwo = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/settlement/SettlementPageStatusTwo.vue')
const SettlementPageStatusFour = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/settlement/SettlementPageStatusFour.vue')
const BrandPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/brand/BrandPage.vue')
const CustomerReserveInfoPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/customerReserveInfo/ShopCustomerReserveInfoPage.vue')

const NoticeLabelPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/noticeLabel/NoticeLabelPage.vue')
const LoginRecordPage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/loginRecord/LoginRecordPage.vue')
const DnkCommunityDevicePage = () => import(/* webpackChunkName: "page-diNaiKe" */ '../views/diNaiKe/dnkCommunityDevice/DnkCommunityDevicePage.vue')
const AreaTreePage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/area/AreaTreePage.vue')
const ShopInfoPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/shopInfo/ShopInfoPage.vue')
const WarehouseProductPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/warehouse/WarehouseProductPage.vue')
const HelpPhonePage = () => import(/* webpackChunkName: "page-village" */ '../views/village/helpPhone/HelpPhonePage.vue')
const OrderStatePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/order/OrderStatePage.vue')
const PropertyNoticeEnroll = () => import(/* webpackChunkName: "page-property" */ '../views/property/notice/PropertyNoticeEnrollPage.vue')
const SelfMentionPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/selfMention/SelfMentionPage.vue')
const SuggestionPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/suggestion/SuggestionPage.vue')
const SuggestionStatisticsForCommunityPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/suggestion/SuggestionStatisticsForCommunityPage.vue')
const SuggestionStatisticsForCustomerPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/suggestion/SuggestionStatisticsForCustomerPage.vue')
const SuggestionCategoryPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/suggestionCategory/SuggestionCategoryPage.vue')
const SuggestionCategoryCustomerPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/suggestionCategoryCustomer/CustomerSuggestionCategoryCustomerPage.vue')
const SuggestionLevelPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/suggestionLevel/SuggestionLevelPage.vue')
const ComboProductPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/comboProduct/ComboProductPage.vue')
const tenementRentingHousePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/rentingHouse/rentingHouse/TenementRentingHousePage.vue')
const tenementRentingAccessoryPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/rentingHouse/rentingAccessory/TenementRentingAccessoryPage.vue')
const tenementRentingShopPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/rentingShop/rentingShop/TenementRentingShopPage.vue')
const rentingAccessoryPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/rentingShop/rentingAccessory/TenementRentingAccessoryPage.vue')


const shopMarketingTypePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/marketingType/ShopMarketingTypePage.vue')
const ProductChargePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productCharge/ShopProductChargePage.vue')
const comboOrdersPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/order/ComboOrdersPage.vue')

//店铺会员
const ShopMemberPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/member/ShopMemberPage.vue')
//会员等级
const ShopMemberGradePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/memberGrade/ShopMemberGradePage.vue')
//店铺体系认证
const ShopAttestationPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/attestation/ShopAttestationPage.vue')
//二手车体系认证
const CarAttestationPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/carAttestation/CarAttestationPage.vue')
//潜客管理
const ShopLatentCustomerPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/latentCustomer/ShopLatentCustomerPage.vue')
//线上线索
const ShopCustomerVisitsInfoPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/latentCustomer/ShopCustomerVisitsInfoPage.vue')
//我的线上线索
const MyShopCustomerVisitsInfoPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/latentCustomer/MyShopCustomerVisitsInfoPage.vue')
//我的线索（接待顾问固定为当前登录用户）
const MyCluesVisitsInfoPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/latentCustomer/MyCluesVisitsInfoPage.vue')
//线上线索去重后的列表，实际使用潜客列表
const ShopCustomerMergeVisitsInfoPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/latentCustomer/ShopCustomerMergeVisitsInfoPage.vue')
//潜客管理
const NewShopLatentCustomerPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/latentCustomer/NewShopLatentCustomerPage.vue')
//潜客战败、无效审核记录
const ShopLatentCustomerAuditRecordPage = () => import(/* webpackChunkName: "page-archive" */'../views/shop/latentCustomer/ShopLatentCustomerAuditRecordPage.vue')
//潜客战败、无效待审核
const shopLatentCustomerAuditWaitPage = ()=> import(/* webpackChunkName: "page-archive" */'../views/shop/latentCustomer/ShopLatentCustomerAuditWaitPage.vue')
const shopLatentCustomerPendingAssignmentPage = ()=> import(/* webpackChunkName: "page-archive" */'../views/shop/latentCustomer/ShopLatentCustomerPendingAssignmentPage.vue')
//战败、无效潜客管理
const ShopLatentCustomerAuditDefeatPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/latentCustomer/ShopLatentCustomerAuditDefeatPage.vue')
//在线寄售
const MotorConsignmentPage = () => import(/* webpackChunkName: "page-shop" */ '../views/motor/consignment/MotorConsignmentPage.vue')
//车辆评估
const MotorEstimatePage = () => import(/* webpackChunkName: "page-shop" */ '../views/motor/estimate/MotorEstimatePage.vue')

const JobPage = () => import(/* webpackChunkName: "page-scheduler" */ '../views/scheduler/job/JobPage.vue')
const JobLogPage = () => import(/* webpackChunkName: "page-scheduler" */ '../views/scheduler/jobLog/JobLogPage.vue')
const signRulePage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/signRule/signRulePage.vue')
const taskTypePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/taskType/TaskTypePage.vue')
const DeviceCategoryPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/deviceCategory/DeviceCategoryPage.vue')
const DevicePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/device/DevicePage.vue')
const DeviceInfoPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/deviceInfo/DeviceInfoPage.vue')
const DeviceRepairPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/deviceRepaire/TenementDeviceRepairePage.vue')
const UpkeepStandardPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/maintenanceStandard/UpkeepStandardPage.vue')
const UpkeepPlandPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/maintenancePlan/UpkeepPlanPage.vue')
const UpkeepTaskPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/maintenanceTask/UpkeepTaskPage.vue')
const UpkeepTaskStatisticsPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/maintenanceTaskStatistics/UpkeepTaskStatisticsPage.vue')
const UpkeepTaskStatisticsForCustomer = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/upkeep/maintenanceTaskStatistics/UpkeepTaskStatisticsForCustomer.vue')

//物业软件后台
const TenementNoticeTypePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/noticeType/NoticeTypePage.vue')
const TenementNoticePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/notice/NoticePage.vue')
const standardPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/standard/StandardPage.vue')
const TenementQualityTypePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qualityCheck/type/QualityTypePage.vue')
const spotPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/spot/SpotPage.vue')
const routePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/route/RoutePage.vue')
const TenementQualityPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qualityCheck/quality/QualityPage.vue')
const AppInterfacePage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/appInterfaceCount/AppInterfacePage.vue')
const TenementQualityOrderPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qualityCheck/qualityOrder/QualityOrderPage.vue')
const inspectionOrder = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/inspectionOrder/InspectionOrderPage.vue')
const TenementQualityStatisticsPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qualityCheck/qualityOrder/QualityStatisticsPage.vue')
const TenementQualityStatisticsForCustomerPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qualityCheck/qualityOrder/QualityStatisticsForCustomerPage.vue')
const TenementQualityRectifyPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qualityCheck/qualityRectify/QualityRectifyPage.vue')

const AssetCategoryPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/category/AssetCategoryPage.vue')
const AssetDepositoryPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/depository/AssetDepositoryPage.vue')
const AssetFaultPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/fault/AssetFaultPage.vue')
const AssetFramePage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/frame/AssetFramePage.vue')
const AssetInPetitionPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/petition/AssetInPetitionPage.vue')
const AssetOutPetitionPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/petition/AssetOutPetitionPage.vue')
const AssetOutPetitionDetailPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/petitionDetail/AssetPetitionDetailPage.vue')
const AssetInPetitionDetailPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/petitionDetail/AssetInPetitionDetailPage.vue')
const AssetAllotPetitionPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/petition/AssetAllotPetitionPage.vue')
const AssetRackPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/rack/AssetRackPage.vue')
const AssetResPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/res/AssetResPage.vue')
const AssetSuplierCompanyPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/supplier/AssetSupplierCompanyPage.vue')
const AssetSuplierCustomerPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/supplier/AssetSupplierCustomerPage.vue')
const AssetUnitPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/unit/AssetUnitPage.vue')
const AssetLibraryPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/library/AssetLibraryPage.vue')
const AssetCheckPage = () => import(/* webpackChunkName: "page-asset" */ '../views/asset/check/AssetCheckPage.vue')

const inspectionStatisticsPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/statistics/StatisticsPage.vue')
const inspectionStatisticsCustomerPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/statistics/StatisticsCustomerPage.vue')
const inspectionStatisticsSpotPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/statistics/StatisticsSpotPage.vue')
const InspectionSpotPrintingPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/inspection/inspectionSpotPrinting/InspectionSpotPrintingPage.vue')

//物业软件后台财务模块
const gaugePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/gauge/financeGauge/TenementFinanceGaugePage.vue')
const gaugeTypePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/gauge/financeGaugeType/TenementFinanceGaugeTypePage.vue')
const meterReadingPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/gauge/financeMeterReading/TenementFinanceMeterReadingPage.vue')
const gaugeHouseRelationPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/gauge/financeGaugeHouseRelation/TenementFinanceGaugeHouseRelationPage.vue')
const mainAnalysisPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/gauge/analysis/MainAnalysisPage.vue')

const ChargeTypePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/financeChargetype/TenementFinanceChargetypePage.vue')
const ChargePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/financeCharge/TenementFinanceChargePage.vue')
const ChargeHousePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/finance/financeChargeHouse/TenementFinanceChargeHousePage.vue')

const QrCodePage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qrCode/QrCodePage.vue')
const QrCodePrintPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/qrCode/print.vue')
const PrintingTemplateqrPage = () => import(/* webpackChunkName: "page-tenement" */ '../views/tenement/printingTemplateqr/PrintingTemplateqrPage.vue')
const insurancePage = () => import(/* webpackChunkName: "page-insurance" */ '../views/insurance/InsurancePage.vue')
const insureInfoPage = () => import(/* webpackChunkName: "page-insureInfo" */ '../views/insureInfo/insureInfoPage.vue')

//物品借用管理
const GoodsManagePage = () => import(/* webpackChunkName: "page-property" */ '../views/property/goodsManage/PropertyGoodsManagePage.vue')
const GoodsBorrowPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/goodsBorrow/PropertyGoodsBorrowPage.vue')
const BorrowLogPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/borrowLog/PropertyBorrowLogPage.vue')
// 服务单
const shopComboConsumedPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/comboConsumed/ShopComboConsumedPage.vue')
const shopComboConsumedTypePage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/comboConsumedType/ShopComboConsumedTypePage.vue')

//活动管理(抽奖券)
const ActivityCouponCodePage = () => import(/* webpackChunkName: "page-activity" */ '../views/activity/couponCode/ActivityCouponCodePage')
const ActivityInfoPage = () => import(/* webpackChunkName: "page-activity" */ '../views/activity/info/ActivityInfoPage')
const ActivityLotteryTicketPage = () => import(/* webpackChunkName: "page-activity" */ '../views/activity/lotteryTicket/ActivityLotteryTicketPage')
const ActivityLotteryTypePage = () => import(/* webpackChunkName: "page-activity" */ '../views/activity/lotteryType/ActivityLotteryTypePage')
const ActivityPrizePage = () => import(/* webpackChunkName: "page-activity" */ '../views/activity/prize/ActivityPrizePage.vue')
const ActivityRegistration = () => import(/* webpackChunkName: "page-activity" */ '../views/activity/activityRegistration/VehicleActivityRegistrationPage.vue')
//错误日志管理
const ErrorLogPage = () => import(/* webpackChunkName: "page-errorLog" */ '../views/errorLog/ErrorLogPage')
//康铭泰克相关
const ComteckShopPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/comteck/comteckShop/ComteckShopPage.vue')
//达达
const ddCityCodePage = () => import(/* webpackChunkName: "page-dada" */ '../views/dada/cityCode/DdCityCodePage')

//国任保险相关
const ShopInfoManagerPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/shopInfoManager/ShopInfoManagerPage.vue')
const parkingSynchronizerPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/parkingSynchronizer/ParkingSynchronizerPage.vue')
const propertyExitstripPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/exitstrip/PropertyExitstripPage.vue')
const carNoHistoryPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/carNo/CarNoHistoryPage.vue')
const suggestionActorPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/suggestion/SuggestionActorPage.vue')
const repairCustomerPage = () => import(/* webpackChunkName: "page-property" */ '../views/property/repair/RepairCustomerPage.vue')
const productChargeClaimPage = () => import(/* webpackChunkName: "page-shop" */ '../views/shop/productChargeClaim/ShopProductChargeClaimPage.vue')

const ShopManagerCodePage = () => import(/* webpackChunkName: "page-basic" */ '../views/basic/managerCode/ShopManagerCodePage.vue')
//调查问卷相关
const SurveySubjectPage = () => import(/* webpackChunkName: "page-survey" */ '../views/survey/subject/SurveySubjectPage.vue')
const SurveySubjectHousePage = () => import(/* webpackChunkName: "page-survey" */ '../views/survey/subjectHouse/SurveySubjectHousePage.vue')
const SurveySubjectResultPage = () => import(/* webpackChunkName: "page-survey" */ '../views/survey/result/SurveySubjectResultPage.vue')
const SurveySubjectFeedbackPage = () => import(/* webpackChunkName: "page-survey" */ '../views/survey/subjectFeedback/SurveySubjectFeedbackPage.vue')
// 合同档案相关
const ArchivesTypePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archives/archivesType/PropertyArchivesTypePage.vue')
const ArchivesStatusPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archives/archivesStatus/PropertyArchivesStatusPage')
const ArchivesPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archives/archives/PropertyArchivesPage.vue')
const RealPayPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archives/archivesRealPay/PropertyArchivesRealPayPage.vue')
const ArchivesJuryAnglePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archivesJury/archivesJuryAngle/PropertyArchivesJuryAnglePage.vue')
const ArchivesJuryPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archivesJury/archivesJury/JuryArchivesPage.vue')
const ArchivesJuryStatisticsPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archivesJury/archivesJuryStatistics/PropertyArchivesJuryStatisticsPage.vue')
const ArchivesStatisticsPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archives/archivesStatistics/PropertyArchivesStatisticsPage.vue')
const ArchivesFinancePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/archives/archivesStatistics/ArchivesStatisticsPage.vue')

//汽车品牌
const CarBrandPage = () => import(/* webpackChunkName: "page-archive" */ '../views/basic/carBrand/BasicCarBrandPage.vue')
const ManufacturerPage = () => import(/* webpackChunkName: "page-archive" */ '../views/basic/manufacturer/BasicManufacturerPage.vue')
const CarSeriesPage = () => import(/* webpackChunkName: "page-archive" */ '../views/basic/carSeries/BasicCarSeriesPage.vue')
const MotorcyclePage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/vehicleMotorcycle/MotorVehicleMotorcyclePage.vue')
const MotorVehiclePage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/vehicle/MotorVehiclePage.vue')
const MotorVehicleAuditPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/vehicleAudit/MotorVehiclePage.vue')
const MotorCallHistoryPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/callHistory/MotorCallHistoryPage.vue')
const MotorVehicleCustomerPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/vehicleCustomer/MotorVehicleCustomerPage.vue')
//车辆合同
const VehicleArchivesManagePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/archivesManage/VehicleArchivesManagePage.vue')
const VehicleInformationManagePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationManage/VehicleInformationManagePage.vue')
const VehicleInformationManageWritePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationManage/VehicleInformationManageWritePage.vue')
const VehicleInformationManageNotAuditStatusPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationManage/VehicleInformationManageNotAuditStatusPage.vue')
const VehicleInformationManageAuditStatusPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationManage/VehicleInformationManageAuditStatusPage.vue')

const VehicleClientManagePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/clientManage/VehicleClientManagePage.vue')
const documentManagePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationManage/DocumentManagePage.vue')
const SealManagePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationManage/SealManagePage.vue')
const SealUserPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationManage/SealUserPage.vue')
const VehicleInformationCostTemplatePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationCostTemplate/VehicleInformationCostTemplatePage.vue')
const informationPrintTemplatePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationPrintTemplate/VehicleInformationPrintTemplatePage.vue')

//售后
const MotorAppointmentPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/appointment/MotorAppointmentPage.vue')
//结算记录
const SqdzBalanceFinanceSettlementPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/sqdzBalanceFinanceSettlement/AasSqdzBalanceFinanceSettlementPage.vue')
//洗美
const MotorBeautyPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/beauty/MotorBeautyPage.vue')
const BeautySetingPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/beautySeting/BeautySetingPage.vue')
const BeautyDevicePage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/beautyDevice/BeautyDevicePage.vue')
const BeautyWashPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/beautyWash/BeautyWashPage.vue')
// 出门条
const OutdoorCertificatePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/outdoorCertificate/PropertyOutdoorCertificatePage.vue')

// 餐券发放记录
const CouponMealCustomerPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/couponMealCustomer/TreasuryCouponMealCustomerPage.vue')
// 餐券核销记录
const CouponMealCustomerPassPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/couponMealCustomerPass/TreasuryCouponMealCustomerPassPage.vue')
// 餐券信息管理
const CouponMealPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/couponMeal/TreasuryCouponMealPage.vue')

const SprayAccountPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/account/SprayAccountPage.vue')
const SprayAccountPageIndex = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/account/SprayAccountPageIndex.vue')
const SprayCompanyRelationPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/companyRelation/SprayCompanyRelationPage.vue')

const SprayAccountLogPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/accountLog/SprayAccountLogPage.vue')

const SprayReservationPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/reservation/SprayReservationPage.vue')

const SprayReservationSitePage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/reservationSite/SprayReservationSitePage.vue')

const SpraySetingPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/seting/SpraySetingPage.vue')

const SpraySitePage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/site/SpraySitePage.vue')

const SpraySiteRentPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/siteRent/SpraySiteRentPage.vue')

const BasicCompanyInvoiceRecordPage = () => import(/* webpackChunkName: "page-archive" */ '../views/basic/companyInvoiceRecord/BasicCompanyInvoiceRecordPage.vue')
const BasicCompanyInvoicePage = () => import(/* webpackChunkName: "page-archive" */ '../views/basic/companyInvoice/BasicCompanyInvoicePage.vue')
const BasicCompanyInvoicePagelist = () => import(/* webpackChunkName: "page-archive" */ '../views/basic/companyInvoice/BasicCompanyInvoicePagelist.vue')
const PropertyBwInvoicePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/bwInvoice/PropertyBwInvoicePage.vue')

//保险续保留资
const renewalInsurancePage = () => import(/* webpackChunkName: "page-archive" */ '../views/insurance/renewalInsurance/InsuranceRenewalInsurancePage.vue');
//保险出现留资
const lossAdvicePage = () => import(/* webpackChunkName: "page-archive" */ '../views/insurance/lossAdvice/InsuranceLossAdvicePage.vue');
// 汽车补贴活动管理
const VehiclePromotionInfoPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/promotionInfo/VehiclePromotionInfoPage.vue');
// 汽车够车信息提交管理
const VehicleBuyInfoPage = () => import(/* webpackChunkName: "page-archive" */ '../views/vehicle/buyInfo/VehicleBuyInfoPage.vue');
// 出租车活动报名记录
const TaxiInfoPage = () => import(/* webpackChunkName: "page-archive" */ '../views/vehicle/taxiInfo/TaxiInfoPage.vue');
// 2025长安汽车园购车节
const chananActivity2025 = () => import(/* webpackChunkName: "page-archive" */ '../views/vehicle/changan2025/index.vue');
//园区活动打卡记录
const ShopCustomerClockNumPage = () => import(/* webpackChunkName: "page-archive" */ '../views/shop/customerClockNum/ShopCustomerClockNumPage.vue');
//外部优惠券
const OutCouponPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/coupon/OutCouponPage.vue');
//优惠券授权记录
const CouponOrderPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/couponOrder/CouponOrderPage.vue');
//外部优惠券统计
const OutCouponStatisticPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/coupon/OutCouponStatisticPage.vue');
//打印设置管理
const TreasuryPrinterShopPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/printerShop/TreasuryPrinterShopPage.vue');
//店铺打印机管理
const TreasuryPrinterInfoPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/printerInfo/TreasuryPrinterInfoPage.vue');
//打印模板管理
const TreasuryPrinterTemplatePage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/printerTemplate/TreasuryPrinterTemplatePage.vue');
//打印日志管理
const TreasuryPrinterLogPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/printerLog/TreasuryPrinterLogPage.vue');
//微断统计
const GaugeStatisticForDayPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/gaugeStatistic/GaugeStatisticForDayPage.vue');
const GaugeStatisticForMonthPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/gaugeStatistic/GaugeStatisticForMonthPage.vue');
const AllGaugeStatisticForMonthPage = () => import(/* webpackChunkName: "page-archive" */ '../views/spray/gaugeStatistic/AllGaugeStatisticForMonthPage.vue');
//优惠券核销记录
const VerifyCouponCustomerPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/couponCustomer/VerifyCouponCustomerPage.vue');
//外部优惠券核销记录
const VerifyExternalCouponPage = () => import(/* webpackChunkName: "page-archive" */ '../views/treasury/couponCustomer/VerifyExternalCouponPage.vue');

//合作企业
const CooperationSuplierCompanyPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/cooperation/CooperationSupplierCompanyPage.vue')
const CooperationSuplierCustomerPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/cooperation/CooperationSupplierCustomerPage.vue')
//二手车业务
const MotorPreparationItemPage = () => import(/* webpackChunkName: "page-asset" */ '../views/motor/preparationItem/MotorPreparationItemPage.vue')
const UsedCarPreparationPage = () => import(/* webpackChunkName: "page-asset" */ '../views/motor/usedCarPreparation/MotorUsedCarPreparationPage.vue')
const UsedCarPreparationSupplierPage = () => import(/* webpackChunkName: "page-asset" */ '../views/motor/usedCarPreparationSupplier/MotorUsedCarPreparationSupplierPage.vue')
//二手车车源信息

// 潜客统计
const potentialStatisticsReport = () => import(/* webpackChunkName: "page-asset" */ '../views/shop/potentialStatistics/report.vue')

// 潜客详情统计
const potentialStatisticsDetail = () => import(/* webpackChunkName: "page-asset" */ '../views/shop/potentialStatistics/detail.vue')

// 潜客详情统计
const potentialPassengerDetail = () => import(/* webpackChunkName: "page-asset" */ '../views/shop/potentialStatistics/passengerDetail.vue')
const UsedCarOrderPage = () => import(/* webpackChunkName: "page-asset" */ '../views/motor/usedCarOrder/MotorUsedCarOrderPage.vue')
const CarComboPage = () => import(/* webpackChunkName: "page-asset" */ '../views/motor/carCombo/MotorCarComboPage.vue')
//二手车评估采购
const usedCarEvaluationPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarEvaluation/usedCarEvaluationPage.vue')
//二手车车源信息
const UsedCarSourcePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarSource/MotorUsedCarSourcePage.vue')
const UsedCarSourceZCPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarSource/MotorUsedCarSourceZCPage.vue')
const UsedCarSourceInputPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarSource/MotorUsedCarSourceInputPage.vue')
const UsedCarSourceReviewPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarSource/MotorUsedCarSourceReviewPage.vue')
const UsedCarSourceReviewedPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarSource/MotorUsedCarSourceReviewedPage.vue')
const UsedCarSourceReceivePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarSource/MotorUsedCarSourceReceivePage.vue')
const UsedCarSourceReceivedPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarSource/MotorUsedCarSourceReceivedPage.vue')
const usedCarDocumentType = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarDocumentType/MotorUsedCarDocumentTypePage.vue')
//二手车过户信息
const UsedCarTransferPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCartransfer/MotorUsedCartransferPage.vue')
//二手车复检分类及复检项
const UsedCarRecheckPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarRecheck/MotorUsedCarRecheckPage.vue')
//二手车复检图片管理
const UsedCarAccessoryClassifyPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarAccessoryClassify/MotorUsedCarAccessoryClassifyPage.vue')
const UsedCarAccessoryTypePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarAccessoryType/MotorUsedCarAccessoryTypePage.vue')
//二手车复检结果管理
const UsedCarResultPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarResult/MotorUsedCarResultPage.vue')
//二手车车辆交接单管理
const UsedCarStorageOrderPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarStorageOrder/MotorUsedCarStorageOrderPage.vue')
//二手车车辆库存管理
const MotorUsedVehiclePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehiclePage.vue')
//车辆库存管理
const MotorUsedNewVehiclePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedNewVehiclePage.vue')
const usedVehicleMakePricePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehicleMakePricePage.vue')
const usedVehiclePutShelvesPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehiclePutShelvesPage.vue')
const usedVehicleNotSoldPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehicleNotSoldPage.vue')
const usedVehicleSoldPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehicleSoldPage.vue')
const usedVehicleBatchSoldPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehicleBatchSoldPage.vue')
const usedVehicleBatchSoldOutPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehicleBatchSoldOutPage.vue')
const usedVehicleDeliverPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehicleDeliverPage.vue')
const usedVehicleInHallPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedVehicle/usedVehicleInHallPage.vue')
// //细分车型管理
// const MotorFineVehicleTypePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/fineVehicleType/MotorFineVehicleTypePage.vue')
//车场设备管理
const CarSquareDevicePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/carSquareDevice/MotorCarSquareDevicePage.vue')
//车场RFID管理
const CarIdentifyPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/carIdentify/MotorCarIdentifyPage.vue')

//二手车客流管理
const MotorUsedCarStoreTrafficPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarStoreTraffic/MotorUsedCarStoreTrafficPage.vue')

//二手车任务管理
const UsedCarTaskPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/usedCarTask/MotorUsedCarTaskPage.vue')
//企业二级人员管理
const CompanyCustomerLevelPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/motor/companyCustomerLevel/MotorCompanyCustomerLevelPage.vue')

//车辆档案费用类别
const VehicleInformationCostClassesParentPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/property/vehicle/informationCostClasses/VehicleInformationCostClassesParentPage.vue')
const VehicleInformationCostClassesPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/property/vehicle/informationCostClasses/VehicleInformationCostClassesPage.vue')
const VehicleClientManageSourcePage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/property/vehicle/clientManageSource/VehicleClientManageSourcePage.vue')
// const VehicleInformationCostClassesPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/property/vehicle/informationCostClasses/VehiclePuviewPage.vue')

//汽车收款通知单
const VehicleInformationCostNotAuditPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationCostReceipts/VehicleInformationCostNotAuditPage.vue')
const VehicleInformationCostAuditPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationCostReceipts/VehicleInformationCostAuditPage.vue')
const VehicleInformationCostReceiptPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationCostReceipts/VehicleInformationCostReceiptPage.vue')
const VehicleInformationCostStatisticsPage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/informationCostStatistics/VehicleInformationCostStatisticsPage.vue')

//企业合同类型
const VehicleArchivesContractTypePage = () => import(/* webpackChunkName: "page-archive" */ '../views/property/vehicle/archivesType/VehicleArchivesContractTypePage.vue')

//企业厅位管理
const MotorShopHallPage = () => import(/* webpackChunkName: "page-archive" */ '../views/motor/shopHall/MotorShopHallPage.vue')
//客流管理
const ShopCustomerVisitsPage  = () => import(/* webpackChunkName: "page-archive" */'../views/shop/customerVisits/ShopCustomerVisitsPage.vue')

//用户组
const BasicStructureGroupUserPage  = () => import(/* webpackChunkName: "page-archive" */'../views/basic/structureGroup/BasicStructureGroupPage.vue')

const latentComeFromByMonth = () => import(/* webpackChunkName: "page-archive" */'../views/statistics/latentComeFromByMonth/index.vue')
const yxLatentComeFromByMonth = () => import(/* webpackChunkName: "page-archive" */'../views/statistics/latentComeFromByMonth/yxIndex.vue')

const latentComeFromByDay =  () => import(/* webpackChunkName: "page-archive" */'../views/statistics/latentComeFromByDay/index.vue')
const yxLatentComeFromByDay =  () => import(/* webpackChunkName: "page-archive" */'../views/statistics/latentComeFromByDay/yxIndex.vue')

const latentComeFromTypeByMonth = () => import(/* webpackChunkName: "page-archive" */'../views/statistics/latentComeFromTypeByMonth/index.vue')

const cjqdPage = () => import(/* webpackChunkName: "page-archive" */'../views/statistics/cjqd/index.vue')

const customerVisitsByDayPage = () => import(/* webpackChunkName: "page-archive" */'../views/statistics/customerVisitsByDay/index.vue')

const customerVisitsByMonthPage = ()=> import(/* webpackChunkName: "page-archive" */'../views/statistics/customerVisitsByMonth/index.vue')

const wdqktjPage = () => import(/* webpackChunkName: "page-archive" */'../views/statistics/wdqktj/index.vue')

//企业二级人员对应潜客
const CompanyLevelLatentCustomerPage = () => import(/* webpackChunkName: "page-usedCar" */ '../views/shop/companyLevelLatentCustomer/CompanyLevelLatentCustomerPage.vue')
const shopLatentAllocatePagePage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/latentAllocate/ShopLatentAllocatePage.vue');

const InvitationRecordPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/invitationRecord/index.vue')

const cluesStatisticsPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/cluesStatistics/index.vue')

const bykhfbtjPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/bykhfbtj/index.vue')

const ztjdPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/ztjd/index.vue')

const xscxPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/xscx/index.vue')

const qkgjjlPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/qkgjjl/index.vue')

const ydlsPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/ydls/index.vue')

const customerVisitStatisticsByDayPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/customerVisitStatisticsByDay/index.vue');

const customerVisitStatisticsByMonthPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/customerVisitStatisticsByMonth/index.vue');

const salesAdvisorVisitsByDayPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/salesAdvisorVisitsByDay/index.vue');

const progressOfCollectionAndSalesPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/progressOfCollectionAndSales/index.vue');

const customersForVehicleSalesPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/customersForVehicleSales/index.vue');

const acquisitionOfVehicleCustomerInformationPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/acquisitionOfVehicleCustomerInformation/index.vue');

const salesOrderStatisticsPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/salesOrderStatistics/index.vue');

const purchaseSaleStockDailyPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/purchaseSaleStockDaily/index.vue');

const usedCarDailyPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/usedCarDaily/index.vue');

const dailySalesDetailsPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/dailySalesDetails/index.vue');

const dailyPurchaseDetailsPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/dailyPurchaseDetails/index.vue');

const usedCarSaleReportPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/usedCarSaleReport/index.vue');

const customerVisitsSuccessPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/customerVisitsSuccess/index.vue');

const customerVisitsContrastPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/statistics/customerVisitsContrast/index.vue');

const VehicleInformationFileTypePage = ()=>import(/* webpackChunkName: "page-archive" */'../views/property/vehicle/informationFileType/VehicleInformationFileTypePage.vue')

const UserLoginRecordPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/basic/userLoginRecord/UserLoginRecordPage.vue')

const InformationCostpayTypePage = ()=>import(/* webpackChunkName: "page-archive" */'../views/property/vehicle/informationCostpayType/VehicleInformationCostpayTypePage.vue')
const SaveReceiptPage = ()=>import(/* webpackChunkName: "page-archive" */'../views/property/receipt/SaveReceiptPage.vue')
Vue.use(Router)

export default new Router({
    routes: [
        {path: '/login', component: LoginPage},
        {path: '/HomeConsole', component: HomeConsole},
        {path: '/helpPage', component: HelpPage},
                {
                    path: '/auth/v1/basic/company/gotoCompanyPage',
                    component: CompanyPage,
                    name: 'basic-CompanyPage'
                },
        {
            path: '/home',
            component: HomePage,
            name: '首页',
            children: [
                // 车辆租赁管理
                {
                    path: '/auth/v1/rental/vehicle/gotoVehicleArchivePage',
                    component: VehicleArchivePage,
                    name: '车辆档案管理'
                },
                {
                    path: '/auth/v1/rental/delivery/gotoVehicleDeliveryRecordPage',
                    component: VehicleDeliveryRecordPage,
                    name: '收发车记录'
                },
                {
                    path: '/auth/v1/rental/maintenance/gotoVehicleMaintenanceRecordPage',
                    component: VehicleMaintenanceRecordPage,
                    name: '车辆保养记录'
                },
                {
                    path: '/auth/v1/rental/daily/gotoVehicleDailyRecordPage',
                    component: VehicleDailyRecordPage,
                    name: '车辆每日状态记录'
                },
                {
                    path: '/auth/v1/rental/statistics/gotoRentalRateStatisticsPage',
                    component: RentalRateStatisticsPage,
                    name: '出租率统计'
                },
                {
                    path: '/auth/v1/rental/faultReport/gotoRentalVehicleFaultReportPage',
                    component: RentalVehicleFaultReportPage,
                    name: '车辆故障报修管理'
                },
                {
                    path: '/home/statistics',
                    component: HomeStatistics,
                    name: '首页统计',
                },
                {path: '/error', component: ErrorPage, name: '异常信息！'},
                {path: '/demoPage', component: DemoPage, name: 'Demo页面！'},
                {
                    path: '/auth/v1/customer/gotoCustomerPage',
                    component: CustomerPage,
                    name: '员工信息管理',
                },
                {
                    path: '/auth/v1/customer/gotoCustomerPageForCompany',
                    component: CustomerPageForCompany,
                    name: '企业超管信息',
                },
                {
                    path: '/auth/v1/customer/gotoUpdatePasswordPage',
                    component: UpdatePasswordPage,
                    name: '密码信息管理',
                },
                {
                    path: '/auth/v1/customer/SwitchAccount',
                    component: SwitchAccount,
                    name: '切换账号',
                },
                {
                    path: '/auth/v1/customer/gotoCustomerInfoPage',
                    component: CustomerInfoPage,
                    name: '用户账号管理',
                },
                {
                    path: '/auth/v1/customer/gotoUpdateCustomerInfoPage',
                    component: UpdateCustomerInfoPage,
                    name: '个人信息',
                },

                {
                    path: '/auth/v1/organization/gotoOrganizationPage',
                    component: OrganizationPage,
                    name: '组织结构管理',
                },
                {
                    path: '/auth/v1/actor/gotoActorPage',
                    component: ActorPage,
                    name: '角色信息管理',
                },
                {
                    path: '/auth/v1/companyActor/gotoCompanyActorPage',
                    component: CompanyActorPage,
                    name: '企业角色信息管理',
                },
                {
                    path: '/auth/v1/position/gotoPositionPage',
                    component: PositionPage,
                    name: '岗位信息管理',
                },
                {
                    path: '/auth/v1/actor/actorOrder/gotoActorOrderPage',
                    component: ActorOrderPage,
                    name: '工单权限管理',
                },
                {
                    path: '/auth/v1/actor/shopInfo/gotoActorShopInfoPage',
                    component: ActorShopInfoPage,
                    name: '角色与店铺关系',
                },
                {
                    path: '/auth/v1/puview/gotoPurviewPage',
                    component: PurviewPage,
                    name: '权限信息管理',
                },
                {
                    path: '/auth/v1/puview/gotoAppPuviewPage',
                    component: AppPuviewPage,
                    name: 'App模块管理',
                },
                {
                    path: '/auth/v1/puview/gotoBasicAppPuviewPage',
                    component: BasicAppPuviewPage,
                    name: 'App模块分配店铺',
                },
                {
                    path: '/auth/v1/puview/gotoAppLabelPage',
                    component: AppLabelPage,
                    name: 'App模块标签管理',
                },
                {
                    path: '/auth/v1/puview/AppToShopPage',
                    component: AppToShopPage,
                    name: 'APP模块绑定店铺',
                },
                {
                    path: '/auth/v1/puview/AppToCommunityPage',
                    component: AppToCommunityPage,
                    name: 'APP模块绑定园区',
                },
                {
                    path: '/auth/v1/document/gotoDocumentPage',
                    component: DocumentPage,
                    name: '平台文档管理',
                },
                {
                    path: '/auth/v1/config/gotoConfigPage',
                    component: ConfigPage,
                    name: '配置信息管理',
                },
                {
                    path: '/auth/v1/city/gotoCityPage',
                    component: CityPage,
                    name: '城市信息管理',
                },
                {
                    path: '/auth/v1/i18n/gotoI18NPage',
                    component: I18nPage,
                    name: '提示信息管理',
                },
                {
                    path: '/auth/v1/keyBook/gotoKeyBookPage',
                    component: KeybookPage,
                    name: '数据字典管理',
                },
                {
                    path: '/auth/v1/generator/gotoGeneratorPage',
                    component: GeneratorPage,
                    name: '生成代码管理',
                },
                {
                    path: '/auth/v1/sms/gotoSmsSendLogPage',
                    component: SmsSendLogPage,
                    name: '短信发送管理',
                },
                {
                    path: '/auth/v1/redis/gotoRedisPage',
                    component: redisPage,
                    name: 'redis管理',
                },
                {
                    path: '/auth/v1/house/customer/gotoHouseCustomerPage',
                    component: HouseCustomerPage,
                    name: '用户认证管理',
                },

                {
                    path: '/auth/v1/house/customer/gotoHouseCustomerDeletePage',
                    component: HouseCustomerDeletePage,
                    name: '已删除账号管理',
                },
                {
                    path: '/auth/v1/property/visitor/gotoVisitorPage',
                    component: VisitorPage,
                    name: '访客管理',
                },
                {
                    path: '/auth/v1/property/faceRecognition/FaceRecognitionPage',
                    component: FaceRecognitionPage,
                    name: '人脸识别管理',
                },
                {
                    path: '/auth/v1/config/gotoConfigItemPage',
                    component: ConfigItemPage,
                    name: '平台配置管理',
                },

                {
                    path: '/auth/v1/building/gotoBuildingPage',
                    component: BuildingPage,
                    name: '楼栋管理',
                },
                {
                    path: '/auth/v1/building/gotoLandMarkPage',
                    component: LandMarkPage,
                    name: '地图管理',
                },
                {
                    path: '/auth/v1/buildingUnit/gotoBuildingUnitPage',
                    component: BuildingUnitPage,
                    name: '单元管理',
                },
                {
                    path: '/auth/v1/community/gotoCommunityPage',
                    component: CommunityPage,
                    name: '园区管理',
                },
                {
                    path: '/auth/v1/evaluate/gotoEvaluatePage',
                    component: EvaluatePage,
                    name: '报修评价管理',
                },
                {
                    path: '/auth/v1/house/gotoHousePage',
                    component: HousePage,
                    name: '房屋管理',
                },
                {
                    path: '/auth/v1/house/gotoHouseFilePage',
                    component: HouseFilePage,
                    name: '房屋档案管理',
                },
                {
                    path: '/auth/v1/houseVisit/gotoHouseVisitPage',
                    component: HouseVisitPage,
                    name: '入户拜访管理',
                },
                {
                    path: '/auth/v1/house/payment/gotoHousePaymentPage',
                    component: HousePaymentPage,
                    name: '应收管理',
                },
                {
                    path: '/auth/v1/house/payment/gotoHousePaymentGroupPage',
                    component: HousePaymentGroupPage,
                    name: '应收统计管理',
                },
                {
                    path: '/auth/v1/house/payment/gotoStatisticsForHousePage',
                    component: StatisticsForHousePage,
                    name: '房屋应收统计',
                },
                {
                    path: '/auth/v1/message/gotoMessagePage',
                    component: MessagePage,
                    name: '消息管理',
                },
                {
                    path: '/auth/v1/notice/gotoShopInfoNoticePage',
                    component: ShopInfoNoticePage,
                    name: '店铺活动管理',
                },
                {
                    path: '/auth/v1/parkActivity/gotoParkActivityPage',
                    component: ParkActivityPage,
                    name: '园区活动管理',
                },
                {
                    path: '/auth/v1/parkActivityRule/gotoParkActivityRulePage',
                    component: ParkActivityRulePage,
                    name: '园区活动规则',
                },
                {
                    path: '/auth/v1/notice/NeighboursPage',
                    component: NeighboursPage,
                    name: '社区公告管理',
                },
                {
                    path: '/auth/v1/notice/log/gotoNoticeLogPage',
                    component: NoticeLogPage,
                    name: '通知阅读管理',
                },
                {
                    path: '/auth/v1/notice/type/gotoNoticeTypePage',
                    component: NoticeTypePage,
                    name: '公告标签管理',
                },
                {
                    path: '/auth/v1/notice/label/gotoNoticeLabelPage',
                    component: NoticeLabelPage,
                    name: '公告分类管理',
                },
                {
                    path: '/auth/v1/notice/label/gotoNoticeInformPage',
                    component: NoticeInformPage,
                    name: '文章举报管理',
                },
                {
                    path: '/auth/v1/notice/label/gotoCommentInformPage',
                    component: CommentInformPage,
                    name: '评论举报管理',
                },
                {
                    path: '/auth/v1/notice/label/gotoReplyInformPage',
                    component: ReplyInformPage,
                    name: '回复举报管理',
                },
                {
                    path: '/auth/v1/receipt/gotoReceiptPage',
                    component: ReceiptPage,
                    name: '实收管理',
                },
                {
                    path: '/auth/v1/receipt/detail/gotoReceiptDetailPage',
                    component: ReceiptDetailPage,
                    name: '实收明细管理',
                },

                {
                    path: '/auth/v1/receipt/detail/gotoReceiptDetailStatisticsByPaymentPage',
                    component: ReceiptDetailStatisticsByPayment,
                    name: '实收明细费项统计',
                },
                {
                    path: '/auth/v1/receipt/detail/gotoReceiptDetailStatisticsByMonthPage',
                    component: ReceiptDetailStatisticsByMonth,
                    name: '实收明细月度统计',
                },
                {
                    path: '/auth/v1/receipt/detailDaily/gotoReceiptDetailDailyStatisticsByPaymentPage',
                    component: ReceiptDetailDailyStatisticsByPayment,
                    name: '实收物业费天粒度',
                },
                {
                    path: '/auth/v1/receiptRefund/gotoReceiptRefundPage',
                    component: ReceiptRefundPage,
                    name: '收据退款单管理',
                },
                {
                    path: '/auth/v1/receiptRefundDetail/gotoReceiptRefundDetailPage',
                    component: ReceiptRefundDetailPage,
                    name: '退款单明细管理',
                },
                {
                    path: '/auth/v1/repair/gotoRepairStatisticsPage',
                    component: RepairStatisticsPage,
                    name: '报修工单统计',
                },
                {
                    path: '/auth/v1/repair/gotoRepairStatisticsForType',
                    component: RepairStatisticsForType,
                    name: '工单分类统计',
                },
                {
                    path: '/auth/v1/repair/gotoRepairStatisticsForSource',
                    component: RepairStatisticsForSource,
                    name: '工单来源统计',
                },
                {
                    path: '/auth/v1/repair/gotoRepairStatisticsForResult',
                    component: RepairStatisticsForResult,
                    name: '工单结果统计',
                },
                {
                    path: '/auth/v1/repair/gotoRepairStatisticsForPerson',
                    component: RepairStatisticsForPerson,
                    name: '个人工单统计',
                },
                {
                    path: '/auth/v1/repair/gotoRepairStatisticsForCommunity',
                    component: RepairStatisticsForCommunity,
                    name: '园区工单统计',
                },
                {
                    path: '/auth/v1/repair/gotoRepairPage',
                    component: RepairPage,
                    name: '物业报修管理',
                },
                {
                    path: '/auth/v1/repair/gotoRepairUserPage',
                    component: RepairUserPage,
                    name: '派单管理',
                },
                {
                    path: '/auth/v1/companyUser/gotoCompanyUserPage',
                    component: CompanyUserPage,
                    name: '物业维修师傅管理',
                },
                {
                    path: '/auth/v1/companyUserCommunity/gotoCompanyUserCommunityPage',
                    component: CompanyUserCommunityPage,
                    name: '物业报修人与园区关系管理',
                },
                {
                    path: '/auth/v1/repair/img/gotoRepairImgPage',
                    component: RepairImgPage,
                    name: '物业报修图片管理',
                },
                {
                    path: '/auth/v1/repair/log/gotoRepairLogPage',
                    component: RepairLogPage,
                    name: '物业报修进度管理',
                },
                {
                    path: '/auth/v1/repair/engineer/gotoRepairEngineerPage',
                    component: RepairEngineerPage,
                    name: '物业报修接单管理',
                },
                {
                    path: '/auth/v1/repair/type/gotoRepairTypePage',
                    component: RepairTypePage,
                    name: '物业报修类型管理',
                },
                {
                    path: '/auth/v1/repair/type/config/gotoRepairTypeCongigPage',
                    component: RepairTypeConfigPage,
                    name: '质保工单分类设置',
                },
                {
                    path: '/auth/v1/property/workRecordType/gotoWorkRecordTypePage',
                    component: WorkRecordTypePage,
                    name: '咨询工单分类',
                },
                {
                    path: '/auth/v1/property/workRecord/gotoWorkRecordPage',
                    component: WorkRecordPage,
                    name: '咨询工单管理',
                },
                {
                    path: '/auth/v1/broadcasting/gotoBroadcastingPage',
                    component: BroadcastingPage,
                    name: '首页轮播图管理',
                },
                {
                    path: '/auth/v1/broadcasting/gotoBroadcastingPageForShop',
                    component: BroadcastingPageForShop,
                    name: '店铺轮播图管理',
                },
                {
                    path: '/auth/v1/twinkle/advertisementTwinkle',
                    component: AdvertisementTwinklePage,
                    name: 'APP闪屏图管理',
                },
                {
                    path: '/auth/v1/popup/advertisementPopup',
                    component: AdvertisementPopupPage,
                    name: 'APP弹窗图管理',
                },
                {
                    path: '/auth/v1/broadcasting/gotoBroadcastingPlatformPage',
                    component: BroadcastingPlatformPage,
                    name: '小程序广告位管理',
                },
                {
                    path: '/auth/v1/cart/gotoCartPage',
                    component: CartPage,
                    name: '购物车管理',
                },
                {
                    path: '/auth/v1/company/gotoCompanyPage',
                    component: CompanyPage,
                    name: '企业管理',
                },
                {
                    path: '/auth/v1/company/gotoCompanyConfPage',
                    component: CompanyConfPage,
                    name: '系统后台配置',
                },
                {
                    path: '/auth/v1/basic/companyConfig/gotoBasicCompanyConfigPage',
                    component: BasicCompanyConfigPage,
                    name: '基础公司配置管理',
                },
                {
                    path: '/auth/v1/order/gotoOrderPage',
                    component: ShopOrderPage,
                    name: '商品订单管理',
                },
                {
                    path: '/auth/v1/order/gotoSelfMentionOrderPage',
                    component: SelfMentionOrderPage,
                    name: '自提点收货订单',
                },
                {
                    path: '/auth/v1/order/gotoOrderStatePage',
                    component: OrderStatePage,
                    name: '订单统计分析',
                },
                {
                    path: '/auth/v1/order/gotoComboOrdersPage',
                    component: comboOrdersPage,
                    name: '套餐商品订单',
                },
                {
                    path: '/auth/v1/order/gotoCommunityOrderPage',
                    component: CommunityOrderPage,
                    name: '企业商品订单管理',
                },
                {
                    path: '/auth/v1/order/detail/gotoOrderDetailPage',
                    component: OrderDetailPage,
                    name: '订单明细管理',
                },
                {
                    path: '/auth/v1/order/log/gotoOrderLogPage',
                    component: OrderLogPage,
                    name: '订单日志管理',
                },
                {
                    path: '/auth/v1/product/gotoProductPage',
                    component: ProductPage,
                    name: '商品管理',
                },
                {
                    path: '/auth/v1/integralProduct/gotoProductPage',
                    component: IntegralProductPage,
                    name: '积分商品管理',
                },
                {
                    path: '/auth/v1/product/gotoComboProductPage',
                    component: ComboProductPage,
                    name: '套餐商品管理',
                },
                {
                    path: '/auth/v1/product/gotoProductTotalSaleStatisticsPage',
                    component: ProductTotalSaleStatisticsPage,
                    name: '商品销量统计',
                },
                {
                    path: '/auth/v1/product/gotoMemberProductPage',
                    component: VipProductPage,
                    name: '会员商品管理',
                },
                {
                    path: '/auth/v1/product/gotoProductPreSalePage',
                    component: productPreSalePage,
                    name: '商品预售管理',
                },
                {
                    path: '/auth/v1/productCharge/gotoProductChargePage',
                    component: ProductChargePage,
                    name: '物业缴费赠送规则',
                },
                {
                    path: '/auth/v1/CarNo/gotoCarNoPage',
                    component: CarNoPage,
                    name: '已售车位车牌管理',
                },
                {
                    path: '/auth/v1/carVisitor/gotoCarVisitorPage',
                    component: CarVisitorPage,
                    name: '访客车辆管理',
                },
                {
                    path: '/auth/v1/carNovel/gotoCarNovelPage',
                    component: CarNovelPage,
                    name: '车牌黑名单',
                },
                {
                    path: '/auth/v1/CarNo/gotoCarNoCZPage',
                    component: CarNoCZPage,
                    name: '出租车位车牌管理',
                },
                {
                    path: '/auth/v1/CarNo/gotoCarNoXKPage',
                    component: CarNoXKPage,
                    name: '销控车位车牌管理',
                },
                {
                    path: '/auth/v1/ParkingSpace/gotoParkingSpacePage',
                    component: ParkingSpacePage,
                    name: '车位信息管理',
                },
                {
                    path: '/auth/v1/product/parkingCustomer/ParkingCustomerPage',
                    component: ParkingCustomerPage,
                    name: '车位使用管理',
                },
                {
                    path: '/auth/v1/parkingGroup/gotoParkingGroupPage',
                    component: ParkingGroupPage,
                    name: '车位成组管理',
                },
                {
                    path: '/auth/v1/parkingPresales/gotoParkingPresalesPage',
                    component: ParkingPresalesPage,
                    name: '车位预售活动',
                },
                {
                    path: '/auth/v1/parkingPresales/gotoParkingPresalesSpacePage',
                    component: ParkingPresalesSpacePage,
                    name: '预售车位管理',
                },
                {
                    path: '/auth/v1/parkingChannel/gotoParkingChannelPage',
                    component: ParkingChannelPage,
                    name: '车道管理',
                },
                {
                    path: '/auth/v1/productHitLog/gotoProductHitPage',
                    component: ProductHitStatisticPage,
                    name: '商品点击量统计',
                },
                {
                    path: '/auth/v1/product/img/gotoProductImgPage',
                    component: ProductImgPage,
                    name: '商品图片管理',
                },
                {
                    path: '/auth/v1/product/info/gotoProductInfoPage',
                    component: ProductInfoPage,
                    name: '商品信息管理',
                },
                {
                    path: '/auth/v1/product/directSelling/gotoDirectSellingPage',
                    component: DirectSellingPage,
                    name: '物业直售商品管理',
                },

                {
                    path: '/auth/v1/product/info/img/gotoProductInfoImgPage',
                    component: ProductInfoImgPage,
                    name: '商品信息图片管理',
                },
                {
                    path: '/auth/v1/product/price/gotoProductPricePage',
                    component: ProductPricePage,
                    name: '商品价格管理',
                },
                {
                    path: '/auth/v1/product/promotion/gotoProductPromotionPage',
                    component: ProductPromotionPage,
                    name: '活动商品管理',
                },
                {
                    path: '/auth/v1/product/store/gotoProductStorePage',
                    component: ProductStorePage,
                    name: '商品库存管理',
                },
                {
                    path: '/auth/v1/product/type/gotoProductTypePage',
                    component: ProductTypePage,
                    name: '商品分类管理',
                },
                {
                    path: '/auth/v1/product/integralType/gotoProductTypePage',
                    component: ProductIntegralTypePage,
                    name: '商品积分分类管理',
                },
                {
                    path: '/auth/v1/promotion/gotoPromotionPage',
                    component: PromotionPage,
                    name: '秒杀活动管理',
                },
                {
                    path: '/auth/v1/promotion/gotoDeletePromotionPage',
                    component: DeletePromotionPage,
                    name: '归档活动管理',
                },
                {
                    path: '/auth/v1/promotion/community/gotoPromotionCommunityPage',
                    component: PromotionCommunity,
                    name: '活动所属园区管理',
                },
                {
                    path: '/auth/v1/return/apply/gotoReturnApplyPage',
                    component: ReturnApplyPage,
                    name: '退货单管理',
                },
                {
                    path: '/auth/v1/refund/order/gotoRefundOrderPage',
                    component: RefundOrderPage,
                    name: '退款单管理',
                },
                {
                    path: '/auth/v1/treasury/coupon/gotoCouponPage',
                    component: CouponPage,
                    name: '优惠券管理',
                },
                {
                    path: '/auth/v1/treasury/couponpack/getCouponPackPage',
                    component: TreasuryCouponPackPage,
                    name: '礼包管理',
                },
                {
                    path: '/auth/v1/treasury/couponCustomer/gotoCouponCustomerPage',
                    component: CouponCustomerPage,
                    name: '用户优惠券管理',
                },
                {
                    path: '/auth/v1/treasury/couponCustomer/gotoAuditCouponCustomerPage',
                    component: AuditCouponCustomerPage,
                    name: '待审核用户优惠券',
                },
                {
                    path: '/auth/v1/treasury/couponpackcustomer/getCouponPackCustomerPage',
                    component: CouponPackCustomerPage,
                    name: '用户礼包管理',
                },
                {
                    path: '/auth/v1/decoration/houseType/gotoHouseTypePage',
                    component: HouseTypePage,
                    name: '户型管理',
                },
                {
                    path: '/auth/v1/decoration/companyCommunity/gotoCompanyCommunityPage',
                    component: CompanyCommunityPage,
                    name: '企业园区关系管理',
                },
                {
                    path: '/auth/v1/decoration/enroll/gotoEnrollPage',
                    component: EnrollPage,
                    name: '装饰报名管理',
                },
                {
                    path:
                        '/auth/v1/decoration/companyInformation/gotoCompanyInformationPage',
                    component: CompanyInformationPage,
                    name: '编辑企业信息',
                },
                {
                    path:
                        '/auth/v1/decoration/companyInformationList/gotoCompanyInformationListPage',
                    component: CompanyInformationListPage,
                    name: '企业信息列表',
                },
                {
                    path: '/auth/v1/decoration/enterprisePhone/gotoEnterprisePhonePage',
                    component: EnterprisePhonePage,
                    name: '企业电话列表',
                },
                {
                    path: '/auth/v1/decoration/phoneLog/gotoPhoneLogPage',
                    component: PhoneLogPage,
                    name: '电话日志列表',
                },
                {
                    path: '/auth/v1/pay/payType/gotoPayTypePage',
                    component: PayTypePage,
                    name: '支付方式管理',
                },
                {
                    path: '/auth/v1/software/gotoSoftwarePage',
                    component: SoftwarePage,
                    name: '手机软件管理',
                },
                {
                    path: '/auth/v1/house/payment/gotoHousePayCountPage',
                    component: HousePayCountPage,
                    name: '房屋缴费情况管理',
                },
                {
                    path: '/auth/v1/shop/bill/gotoShopBillPage',
                    component: ShopBillPage,
                    name: '支付账单流水',
                },
                {
                    path: '/auth/v1/shop/bill/gotoShopBillFailPage',
                    component: ShopBillFailPage,
                    name: '对账失败账单',
                },
                {
                    path: '/auth/v1/shop/bill/gotoShopBillSuccessPage',
                    component: ShopBillSuccessPage,
                    name: '对账成功账单',
                },
                {
                    path: '/auth/v1/shop/settlement/gotoSettlementPage',
                    component: SettlementPage,
                    name: '结算单管理',
                },
                {
                    path: '/auth/v1/shop/settlement/gotoSettlementPageStatusOne',
                    component: SettlementPageStatusOne,
                    name: '待处理结算单',
                },
                {
                    path: '/auth/v1/shop/settlement/gotoSettlementPageStatusTwo',
                    component: SettlementPageStatusTwo,
                    name: '待结算结算单',
                },
                {
                    path: '/auth/v1/shop/settlement/gotoSettlementPageStatusFour',
                    component: SettlementPageStatusFour,
                    name: '已完成结算单',
                },
                {
                    path: '/auth/v1/shop/brand/gotoBrandPage',
                    component: BrandPage,
                    name: '商品品牌管理',
                },
                {
                    path: '/auth/v1/shop/customerReserveInfo/gotoCustomerReserveInfoPage',
                    component: CustomerReserveInfoPage,
                    name: '留资信息',
                },
                {
                    path: '/auth/v1/loginRecord/gotoLoginRecordPage',
                    component: LoginRecordPage,
                    name: 'App在线用户列表',
                },
                {
                    path: '/auth/v1/diNaiKe/gotoDnkCommunityDevicePage',
                    component: DnkCommunityDevicePage,
                    name: '门禁设备管理',
                },
                {
                    path: '/auth/v1/area/gotoAreaTreePage',
                    component: AreaTreePage,
                    name: '地区管理',
                },
                {
                    path: '/auth/v1/shopInfo/gotoShopInfoPage',
                    component: ShopInfoPage,
                    name: '店铺信息管理',
                },
                {
                    path: '/auth/v1/warehouse/product/gotoWarehouseProductPage',
                    component: WarehouseProductPage,
                    name: '商品仓库',
                },
                {
                    path: '/auth/v1/village/helpPhone/gotoHelpPhonePage',
                    component: HelpPhonePage,
                    name: '园区服务',
                },
                {
                    path: '/auth/v1/property/notice/gotoPropertyNoticeEnroll',
                    component: PropertyNoticeEnroll,
                    name: '活动报名管理',
                },
                {
                    path: '/auth/v1/shop/selfMention/SelfMentionPage',
                    component: SelfMentionPage,
                    name: '自提点管理',
                },
                {
                    path: '/auth/v1/property/suggestion/gotoSuggestionPage',
                    component: SuggestionPage,
                    name: '投诉建议管理',
                },
                {
                    path: '/auth/v1/property/suggestion/CustomerSuggestionCategoryActorPage',
                    component: SuggestionStatisticsForCommunityPage,
                    name: '投诉建议项目统计',
                },
                {
                    path: '/auth/v1/property/suggestion/gotoSuggestionStatisticsForCustomerPage',
                    component: SuggestionStatisticsForCustomerPage,
                    name: '投诉建议人员统计',
                },
                {
                    path: '/auth/v1/property/suggestionCategory/gotoSuggestionCategoryPage',
                    component: SuggestionCategoryPage,
                    name: '投诉建议分类管理',
                },
                {
                    path: '/auth/v1/property/suggestionCategoryCustomer/gotoSuggestionCategoryCustomerPage',
                    component: SuggestionCategoryCustomerPage,
                    name: '投诉建议用户分类管理',
                },
                {
                    path: '/auth/v1/property/suggestionlevel/gotoSuggestionLevelPage',
                    component: SuggestionLevelPage,
                    name: '投诉建议分级管理',
                },
                {
                    path: '/auth/v1/job/gotoJobPage',
                    component: JobPage,
                    name: '定时任务管理',
                },
                {
                    path: '/auth/v1/job/gotoJobLogPage',
                    component: JobLogPage,
                    name: '定时任务日志管理',
                },
                {
                    path: '/auth/v1/baic/signRule/gotoSignRulePage',
                    component: signRulePage,
                    name: '签到规则管理',
                },
                {
                    path: '/auth/v1/tenement/taskType/gotoTaskTypePage',
                    component: taskTypePage,
                    name: '任务类型管理',
                },
                {
                    path: '/auth/v1/customer/gotoCountAreaCustomerRegisteredPage',
                    component: CountAreaCustomerRegisteredPage,
                    name: '乡村用户注册量统计',
                },
                {
                    path: '/auth/v1/app/interface/gotoAppInterfacePage',
                    component: AppInterfacePage,
                    name: 'APP接口点击量统计',
                },

                //物业管理软件
                {
                    path: '/auth/v1/tenement/device/gotoDeviceCategoryPage',
                    component: DeviceCategoryPage,
                    name: '设备类别管理',
                },
                {
                    path: '/auth/v1/tenement/device/gotoDevicePage',
                    component: DevicePage,
                    name: '设备组管理',
                },
                {
                    path: '/auth/v1/tenement/device/gotoDeviceInfoPage',
                    component: DeviceInfoPage,
                    name: '设备台账管理',
                },
                {
                    path: '/auth/v1/tenement/device/gotoDeviceRepairPage',
                    component: DeviceRepairPage,
                    name: '设备维修管理',
                },
                {
                    path: '/auth/v1/tenement/upkeep/gotoUpkeepStandardPage',
                    component: UpkeepStandardPage,
                    name: '保养标准管理',
                },
                {
                    path: '/auth/v1/tenement/upkeep/gotoUpkeepPlandPage',
                    component: UpkeepPlandPage,
                    name: '保养计划管理',
                },
                {
                    path: '/auth/v1/tenement/upkeep/gotoUpkeepTaskPage',
                    component: UpkeepTaskPage,
                    name: '保养任务单管理',
                },
                {
                    path: '/auth/v1/tenement/upkeep/gotoUpkeepTaskStatisticsPage',
                    component: UpkeepTaskStatisticsPage,
                    name: '园区任务单统计',
                },
                {
                    path: '/auth/v1/tenement/upkeep/gotoUpkeepTaskStatisticsForCustomer',
                    component: UpkeepTaskStatisticsForCustomer,
                    name: '人员任务单统计',
                },
                {
                    path: '/auth/v1/tenement/noticeType/gotoNoticeTypePage',
                    component: TenementNoticeTypePage,
                    name: '公告类型管理',
                },
                {
                    path: '/auth/v1/tenement/notice/gotoNoticePage',
                    component: TenementNoticePage,
                    name: '通知公告管理',
                },
                {
                    path: '/auth/v1/tenement/inspection/standard/StandardPage',
                    component: standardPage,
                    name: '巡检点标准管理',
                },
                {
                    path: '/auth/v1/tenement/qualityType/gotoQualityTypePage',
                    component: TenementQualityTypePage,
                    name: '品质核查类型',
                },
                {
                    path: '/auth/v1/tenement/inspection/spot/SpotPage',
                    component: spotPage,
                    name: '巡检点管理',
                },
                {
                    path:
                        '/auth/v1/tenement/inspection/inspectionSpotPrinting/InspectionSpotPrintingPage',
                    component: InspectionSpotPrintingPage,
                    name: '巡检点打印',
                },
                {
                    path: '/auth/v1/tenement/inspection/route/RoutePage',
                    component: routePage,
                    name: '巡检路线管理',
                },
                {
                    path: '/auth/v1/tenement/quality/gotoQualityPage',
                    component: TenementQualityPage,
                    name: '品质核查标准',
                },
                {
                    path:
                        '/auth/v1/tenement/inspection/inspectionOrder/InspectionOrderPage',
                    component: inspectionOrder,
                    name: '巡检工单管理',
                },
                {
                    path: '/auth/v1/tenement/qualityOrder/gotoQualityOrderPage',
                    component: TenementQualityOrderPage,
                    name: '品质核查单管理',
                },
                {
                    path: '/auth/v1/tenement/qualityOrder/gotoQualityStatisticsPage',
                    component: TenementQualityStatisticsPage,
                    name: '品质核查单统计',
                },
                {
                    path:
                        '/auth/v1/tenement/qualityOrder/gotoQualityStatisticsForCustomerPage',
                    component: TenementQualityStatisticsForCustomerPage,
                    name: '员工品质统计',
                },
                {
                    path: '/auth/v1/tenement/qualityRectify/gotoQualityRectifyPage',
                    component: TenementQualityRectifyPage,
                    name: '品质整改单管理',
                },

                {
                    path: '/auth/v1/asset/category/gotoAssetCategoryPage',
                    component: AssetCategoryPage,
                    name: '资产分类管理',
                },
                {
                    path: '/auth/v1/asset/depository/gotoAssetDepositoryPage',
                    component: AssetDepositoryPage,
                    name: '资产仓库管理',
                },
                {
                    path: '/auth/v1/asset/fault/gotoAssetFaultPage',
                    component: AssetFaultPage,
                    name: '资产维修类型',
                },
                {
                    path: '/auth/v1/asset/frame/gotoAssetFramePage',
                    component: AssetFramePage,
                    name: '资产货位管理',
                },
                {
                    path: '/auth/v1/asset/petition/gotoAssetInPetitionPage',
                    component: AssetInPetitionPage,
                    name: '入库申请',
                },
                {
                    path: '/auth/v1/asset/petition/gotoAssetOutPetitionPage',
                    component: AssetOutPetitionPage,
                    name: '出库申请',
                },
                {
                    path: '/auth/v1/asset/petition/gotoAssetOutPetitionDetailPage',
                    component: AssetOutPetitionDetailPage,
                    name: '出库明细',
                },
                {
                    path: '/auth/v1/asset/petition/gotoAssetInPetitionDetailPage',
                    component: AssetInPetitionDetailPage,
                    name: '入库明细',
                },
                {
                    path: '/auth/v1/asset/petition/gotoAssetAllotPetitionPage',
                    component: AssetAllotPetitionPage,
                    name: '调拨申请',
                },
                {
                    path: '/auth/v1/asset/rack/gotoAssetRackPage',
                    component: AssetRackPage,
                    name: '资产货架',
                },
                {
                    path: '/auth/v1/asset/res/gotoAssetResPage',
                    component: AssetResPage,
                    name: '资产信息管理',
                },
                {
                    path: '/auth/v1/asset/res/gotoAssetCheckPage',
                    component: AssetCheckPage,
                    name: '资产盘点',
                },
                {
                    path: '/auth/v1/asset/res/gotoAssetSuplierCompanyPage',
                    component: AssetSuplierCompanyPage,
                    name: '公司',
                },
                {
                    path: '/auth/v1/asset/res/gotoAssetSuplierCustomerPage',
                    component: AssetSuplierCustomerPage,
                    name: '个人',
                },
                {
                    path: '/auth/v1/asset/res/gotoAssetUnitPage',
                    component: AssetUnitPage,
                    name: '计量单位管理',
                },
                {
                    path: '/auth/v1/asset/Library/gotoAssetLibraryPage',
                    component: AssetLibraryPage,
                    name: '物品档案管理',
                },
                {
                    path: '/auth/v1/tenement/inspection/statistics/StatisticsPage',
                    component: inspectionStatisticsPage,
                    name: '项目巡检工单统计',
                },
                {
                    path:
                        '/auth/v1/tenement/inspection/statistics/StatisticsCustomerPage',
                    component: inspectionStatisticsCustomerPage,
                    name: '人员巡检工单统计',
                },
                {
                    path: '/auth/v1/tenement/inspection/statistics/StatisticsSpotPage',
                    component: inspectionStatisticsSpotPage,
                    name: '巡检工单点位统计',
                },

                {
                    path: '/auth/v1/tenement/finance/gauge/gotoGaugeTypePage',
                    component: gaugeTypePage,
                    name: '费表类型设置',
                },
                {
                    path: '/auth/v1/tenement/finance/gauge/gotoGaugePage',
                    component: gaugePage,
                    name: '费表基本档案',
                },
                {
                    path: '/auth/v1/tenement/finance/gauge/gotoGaugeHouseRelationPage',
                    component: gaugeHouseRelationPage,
                    name: '费表与房屋关系',
                },
                {
                    path: '/auth/v1/tenement/finance/gauge/gotoMeterReadingPage',
                    component: meterReadingPage,
                    name: '抄表设置',
                },
                {
                    path: '/auth/v1/tenement/finance/gauge/gotoMainAnalysisPage',
                    component: mainAnalysisPage,
                    name: '能效分析',
                },
                {
                    path: '/auth/v1/monitor/server/gotoServerInfoPage',
                    component: ServerInfoPage,
                    name: '服务监控信息',
                },
                {
                    path: '/auth/v1/tenement/finance/charge/gotoChargeTypePage',
                    component: ChargeTypePage,
                    name: '费项基本档案',
                },
                {
                    path: '/auth/v1/tenement/finance/charge/gotoChargePage',
                    component: ChargePage,
                    name: '费项收费规则',
                },
                {
                    path: '/auth/v1/tenement/finance/chargeHouse/gotoChargeHousePage',
                    component: ChargeHousePage,
                    name: '费项与房屋关系',
                },

                {
                    path: '/auth/v1/tenement/qrCode/qrCodePage',
                    component: QrCodePage,
                    name: '打印二维码',
                },
                {
                    path: '/auth/v1/tenement/printingTemplateqr/printingTemplateqrPage',
                    component: PrintingTemplateqrPage,
                    name: '打印二维码模板管理',
                },
                {
                    path: '/auth/v1/insurance/insurancePage',
                    component: insurancePage,
                    name: '保险信息管理',
                },
                {
                    path: '/auth/v1/insureInfo/insureInfoPage',
                    component: insureInfoPage,
                    name: '投保信息',
                },

                //物品借用管理
                {
                    path: '/auth/v1/property/goodsmanage/getGoodsManagePage',
                    component: GoodsManagePage,
                    name: '物品管理',
                },
                {
                    path: '/auth/v1/property/goodsborrow/getGoodsBorrowPage',
                    component: GoodsBorrowPage,
                    name: '物品借用',
                },
                {
                    path: '/auth/v1/property/borrowlog/getBorrowLogPage',
                    component: BorrowLogPage,
                    name: '物品借用操作日志',
                },
                {
                    path: '/auth/v1/shop/comboConsumed/getComboConsumedPage',
                    component: shopComboConsumedPage,
                    name: '服务单',
                },
                {
                    path: '/auth/v1/shop/comboConsumed/getComboConsumedTypePage',
                    component: shopComboConsumedTypePage,
                    name: '服务单类型',
                },

                //活动管理(抽奖券)
                {
                    path: '/auth/v1/activity/CouponCode/ActivityCouponCodePage',
                    component: ActivityCouponCodePage,
                    name: '抽奖券码管理',
                },
                {
                    path: '/auth/v1/activity/info/ActivityInfoPage',
                    component: ActivityInfoPage,
                    name: '活动管理',
                },
                {
                    path: '/auth/v1/activity/lotteryTicket/ActivityLotteryTicketPage',
                    component: ActivityLotteryTicketPage,
                    name: '抽奖券发放管理',
                },
                {
                    path: '/auth/v1/activity/lotteryType/ActivityLotteryTypePage',
                    component: ActivityLotteryTypePage,
                    name: '业务类型管理',
                },
                {
                    path: '/auth/v1/activity/lotteryType/gotoActivityPrizePage',
                    component: ActivityPrizePage,
                    name: '奖项管理',
                },
                {
                    path: '/auth/v1/activity/lotteryType/gotoActivityRegistrationPage',
                    component: ActivityRegistration,
                    name: '报名管理',
                },
                //康铭泰克相关
                {
                    path: '/auth/v1/shop/comteck/gotoComteckShopPage',
                    component: ComteckShopPage,
                    name: '康铭泰克店铺管理',
                },
                //错误日志管理
                {
                    path: '/auth/v1/errorLog/gotoErrorLogPage',
                    component: ErrorLogPage,
                    name: '错误日志管理',
                },
                {
                    path: '/auth/v1/shop/marketingType/shopMarketingTypePage',
                    component: shopMarketingTypePage,
                    name: '店铺经营类型管理',
                },
                {
                    path: '/auth/v1/dada/cityCode/ddCityCodePage',
                    component: ddCityCodePage,
                    name: '达达城市管理',
                },
                {
                    path: '/auth/v1/shop/manager/gotoShopInfoManagerPage',
                    component: ShopInfoManagerPage,
                    name: '服务站经理管理',
                },
                {
                    path: '/auth/v1/page/property/parkingSynchronizer/gotoParkingSynchronizerPage',
                    component: parkingSynchronizerPage,
                    name: '车牌同步日志',
                },
                {
                    path: '/auth/v1/page/property/exitstrip/PropertyExitstripPage',
                    component: propertyExitstripPage,
                    name: '出门条管理',
                },
                {
                    path: '/auth/v1/page/shop/ShopProductChargeClaimPage',
                    component: productChargeClaimPage,
                    name: '赠送桶装水',
                },
                {
                    path: '/auth/v1/page/tenement/TenementRentingHousePage',
                    component: tenementRentingHousePage,
                    name: '房屋租售',
                },
                {
                    path: '/auth/v1/page/tenement/TenementRentingAccessoryPage',
                    component: tenementRentingAccessoryPage,
                    name: '房屋配套',
                },
                {
                    path: '/auth/v1/page/tenement/TenementRentingShopPage',
                    component: tenementRentingShopPage,
                    name: '商铺出租',
                },
                {
                    path: '/auth/v1/page/tenement/rentingAccessoryPage',
                    component: rentingAccessoryPage,
                    name: '商铺配套',
                },
                {
                    path: '/auth/v1/page/property/carNo/CarNoHistoryPage',
                    component: carNoHistoryPage,
                    name: '车牌删除历史数据管理',
                },
                {
                    path: '/auth/v1/page/property/suggestion/SuggestionActorPage',
                    component: suggestionActorPage,
                    name: '投诉建议信息处理管理',
                },
                {
                    path: '/auth/v1/property/repair/RepairCustomerPage',
                    component: repairCustomerPage,
                    name: '报修工单跟进',
                },
                {
                    path: '/auth/v1/property/pushTemplate/gotoNotificationTemplatePositionPage',
                    component: NotificationTemplatePositionPage,
                    name: '推送提示音管理',
                },
                {
                    path: '/auth/v1/basic/managerCode/gotoShopManagerCodePage',
                    component: ShopManagerCodePage,
                    name: '小程序推广信息',
                },
                {
                    path: '/auth/v1/survey/subject/gotoSurveySubjectPage',
                    component: SurveySubjectPage,
                    name: '调查问卷标题',
                },
                {
                    path: '/auth/v1/survey/subjectHouse/gotoSurveySubjectHousePage',
                    component: SurveySubjectHousePage,
                    name: '调查问卷发送记录',
                },
                {
                    path: '/auth/v1/survey/subjectHouse/gotoSurveySubjectResultPage',
                    component: SurveySubjectResultPage,
                    name: '调查问卷结果',
                },
                {
                    path: '/auth/v1/survey/subjectHouse/gotoSurveySubjectFeedbackPage',
                    component: SurveySubjectFeedbackPage,
                    name: '调查问卷答题记录',
                },
                // 合同档案相关
                {
                    path: '/auth/v1/property/archives/gotoArchivesTypePage',
                    component: ArchivesTypePage,
                    name: '合同类别管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoArchivesStatusPage',
                    component: ArchivesStatusPage,
                    name: '合同状态管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoArchivesPage',
                    component: ArchivesPage,
                    name: '合同档案管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoRealPayPage',
                    component: RealPayPage,
                    name: '合同实收管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoArchivesJuryPage',
                    component: ArchivesJuryAnglePage,
                    name: '评价维度管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoJuryArchivesPage',
                    component: ArchivesJuryPage,
                    name: '合同评价管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoArchivesStatisticsPage',
                    component: ArchivesJuryStatisticsPage,
                    name: '评价统计管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoArchivesStatistics',
                    component: ArchivesStatisticsPage,
                    name: '合同统计管理',
                },
                {
                    path: '/auth/v1/property/archives/gotoArchivesFinancePage',
                    component: ArchivesFinancePage,
                    name: '合同财务统计',
                },
                {
                    path: '/auth/v1/shop/member/getMemberPage',
                    component: ShopMemberPage,
                    name: '店铺会员管理',
                },
                {
                    path: '/auth/v1/shop/membergrade/getMemberGradePage',
                    component: ShopMemberGradePage,
                    name: '会员等级管理',
                },
                {
                    path: '/auth/v1/shop/attestation/getAttestationPage',
                    component: ShopAttestationPage,
                    name: '体系认证管理',
                },
                {
                    path: '/auth/v1/car/attestation/getCarAttestationPage',
                    component: CarAttestationPage,
                    name: '二手车认证',
                },
                {
                    path: '/auth/v1/shop/latentcustomer/getLatentCustomerPage',
                    component: ShopLatentCustomerPage,
                    name: '二手车潜客管理',
                },
                {
                    path: '/auth/v1/shop/latentcustomer/getShopCustomerVisitsInfoPage',
                    component: ShopCustomerVisitsInfoPage,
                    name: '线索管理',
                },
                {
                    path: '/auth/v1/shop/latentcustomer/getMyShopCustomerVisitsInfoPage',
                    component: MyShopCustomerVisitsInfoPage,
                    name: '我的线索管理',
                },
                {
                    path: '/auth/v1/shop/latentcustomer/getMyCluesVisitsInfoPage',
                    component: MyCluesVisitsInfoPage,
                    name: '我的线索',
                },
                {
                    path: '/auth/v1/shop/latentcustomer/getShopCustomerMergeVisitsInfoPage',
                    component: ShopCustomerMergeVisitsInfoPage,
                    name: '去重线索管理',
                },
                {
                    path: '/auth/v1/shop/latentcustomer/getNewLatentCustomerPage',
                    component: NewShopLatentCustomerPage,
                    name: '新车潜客管理',
                },
                {
                    path: '/auth/v1/shop/latentCustomer/shopLatentCustomerAuditRecordPage',
                    component: ShopLatentCustomerAuditRecordPage,
                    name: '潜客审批记录',
                },
                {
                    path: '/auth/v1/shop/latentCustomer/shopLatentCustomerAuditWaitPage',
                    component: shopLatentCustomerAuditWaitPage,
                    name: '无效战败待审核',
                },
                {
                    path: '/auth/v1/shop/latentCustomer/shopLatentCustomerPendingAssignmentPage',
                    component: shopLatentCustomerPendingAssignmentPage,
                    name: '潜客待分配',
                },
                {
                    path: '/latentCustomer/ShopLatentCustomerAuditDefeatPage',
                    component: ShopLatentCustomerAuditDefeatPage,
                    name: '无效战败潜客',
                },
                {
                    path: '/auth/v1/basic/carBrand/gotoCarBrandPage',
                    component: CarBrandPage,
                    name: '汽车品牌管理',
                },
                {
                    path: '/auth/v1/basic/manufacturer/gotoManufacturerPage',
                    component: ManufacturerPage,
                    name: '汽车厂商管理',
                },
                {
                    path: '/auth/v1/basic/carSeries/gotoCarSeriesPage',
                    component: CarSeriesPage,
                    name: '车系管理',
                },
                {
                    path: '/auth/v1/basic/motorcycle/gotoMotorcyclePage',
                    component: MotorcyclePage,
                    name: '车型管理',
                },
                {
                    path: '/auth/v1/motor/vehicle/gotoMotorVehiclePage',
                    component: MotorVehiclePage,
                    name: '新车管理',
                },
                {
                    path: '/auth/v1/motor/vehicleAudit/gotoMotorVehiclePage',
                    component: MotorVehicleAuditPage,
                    name: '新车审核管理',
                },
                {
                    path: '/auth/v1/motor/callHistory/gotoMotorCallHistoryPage',
                    component: MotorCallHistoryPage,
                    name: '拨号记录',
                },
                {
                    path: '/auth/v1/motor/vehicleCustomer/gotoMotorVehicleCustomerPage',
                    component: MotorVehicleCustomerPage,
                    name: '客户车辆信息',
                },
                {
                    path: '/auth/v1/vehicle/archivesmanage/getArchivesManagePage',
                    component: VehicleArchivesManagePage,
                    name: '车辆合同管理',
                },
                {
                    path: '/auth/v1/motor/consignment/getConsignmentPage',
                    component: MotorConsignmentPage,
                    name: '在线寄售',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationManagePage',
                    component: VehicleInformationManagePage,
                    name: '车辆档案信息管理',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationManageWritePage',
                    component: VehicleInformationManageWritePage,
                    name: '填写中车辆档案',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationManageNotAuditStatusPage',
                    component: VehicleInformationManageNotAuditStatusPage,
                    name: '待审核中车辆档案',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationManageAuditStatusPage',
                    component: VehicleInformationManageAuditStatusPage,
                    name: '已审核中车辆档案',
                },
                {
                    path: '/auth/v1/vehicle/InformationCostTemplate/gotoInformationCostTemplatePage',
                    component: VehicleInformationCostTemplatePage,
                    name: '档案费用模板管理',
                },
                {
                    path: '/auth/v1/vehicle/InformationPrintTemplate/informationPrintTemplatePage',
                    component: informationPrintTemplatePage,
                    name: '档案费用打印模板管理',
                },
                {
                    path: '/auth/v1/vehicle/clientManage/gotoClientManagePage',
                    component: VehicleClientManagePage,
                    name: '客户认证管理',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoDocumentManagePage',
                    component: documentManagePage,
                    name: '合同模板管理',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoSealManagePage',
                    component: SealManagePage,
                    name: '电子签章管理',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoSealUserPage',
                    component: SealUserPage,
                    name: '电子签成员管理',
                },
                {
                    path: '/auth/v1/motor/estimate/getEstimatePage',
                    component: MotorEstimatePage,
                    name: '车辆评估',
                },
                {
                    path: '/auth/v1/motor/appointment/gotoMotorAppointmentPage',
                    component: MotorAppointmentPage,
                    name: '预约维保管理',
                },
                {
                    path: '/auth/v1/sqdzbalancefinancesettlement/getSqdzBalanceFinanceSettlementPage',
                    component: SqdzBalanceFinanceSettlementPage,
                    name: '结算记录管理',
                },
                {
                    path: '/auth/v1/motor/beauty/gotoMotorBeautyPage',
                    component: MotorBeautyPage,
                    name: '预约洗美管理',
                },
                {
                    path: '/auth/v1/motor/beautySeting/gotoBeautySetingPage',
                    component: BeautySetingPage,
                    name: '洗美中心配置管理',
                },
                {
                    path: '/auth/v1/motor/beautyDevice/gotoBeautyDevicePage',
                    component: BeautyDevicePage,
                    name: '洗车机设备管理',
                },
                {
                    path: '/auth/v1/motor/beautyWash/gotoBeautyWashPage',
                    component: BeautyWashPage,
                    name: '洗车记录管理',
                },
                {
                    path: '/auth/v1/treasury/couponmeal/gotoCouponMealPage',
                    component: CouponMealPage,
                    name: '餐券信息管理',
                },
                {
                    path: '/auth/v1/treasury/couponmealcustomer/getCouponMealCustomerPage',
                    component: CouponMealCustomerPage,
                    name: '餐券发放记录',
                },
                {
                    path: '/auth/v1/treasury/couponmealcustomer/getCouponMealCustomerPassPage',
                    component: CouponMealCustomerPassPage,
                    name: '餐券核销记录',
                },
                {
                    path: '/auth/v1/property/outdoorCertificate/gotoOutdoorCertificatePage',
                    component: OutdoorCertificatePage,
                    name: '出门条',
                },
                {
                    path: '/auth/v1/property/vehicleNo/gotoVehicleNoPage',
                    component: VehicleNoPage,
                    name: '员工车牌管理',
                },
                {
                    path: '/auth/v1/property/vehicleNo/gotoVehicleNoOfficePage',
                    component: VehicleNoOfficePage,
                    name: '办公车牌管理',
                },
                {
                    path: '/auth/v1/spray/account/gotoSprayAccountPage',
                    component: SprayAccountPage,
                    name: '喷涂币管理',
                },
                {
                    path: '/auth/v1/spray/account/gotoSprayAccountPageIndex',
                    component: SprayAccountPageIndex,
                    name: '企业喷涂币账户',
                },
                {
                    path: '/auth/v1/spray/companyRelation/gotoSprayCompanyRelationPage',
                    component: SprayCompanyRelationPage,
                    name: '喷涂中心4s店管理',
                },
                {
                    path: '/auth/v1/spray/accountLog/gotoSprayAccountLogPage',
                    component: SprayAccountLogPage,
                    name: '喷涂币交易日志管理',
                },
                {
                    path: '/auth/v1/spray/reservation/gotoSprayReservationPage',
                    component: SprayReservationPage,
                    name: '预约单管理',
                },
                {
                    path: '/auth/v1/spray/reservationSite/gotoSprayReservationSitePage',
                    component: SprayReservationSitePage,
                    name: '预约单场地管理',
                },
                {
                    path: '/auth/v1/spray/seting/gotoSpraySetingPage',
                    component: SpraySetingPage,
                    name: '喷涂中心配置管理',
                },
                {
                    path: '/auth/v1/spray/site/gotoSpraySitePage',
                    component: SpraySitePage,
                    name: '场地管理',
                },
                {
                    path: '/auth/v1/spray/siteRent/gotoSpraySiteRentPage',
                    component: SpraySiteRentPage,
                    name: '场地租赁管理',
                },
                {
                    path: '/auth/v1/basic/companyInvoice/gotoBasicCompanyInvoicePage',
                    component: BasicCompanyInvoicePage,
                    name: '发票信息管理',
                },
                {
                    path: '/auth/v1/basic/companyInvoice/gotoBasicCompanyInvoicePageList',
                    component: BasicCompanyInvoicePagelist,
                    name: '企业开票账号',
                },
                {
                    path: '/auth/v1/basic/companyInvoiceRecord/gotoBasicCompanyInvoiceRecordPage',
                    component: BasicCompanyInvoiceRecordPage,
                    name: '开票记录管理',
                },
                {
                    path: '/auth/v1/property/bwInvoice/gotoBwInvoicePage',
                    component: PropertyBwInvoicePage,
                    name: '电子发票管理',
                },
                {
                    path: '/auth/v1/insurance/renewalInsurance/gotoRenewalInsurancePage',
                    component: renewalInsurancePage,
                    name: '续保管理',
                },
                {
                    path: '/auth/v1/insurance/lossAdvice/gotoLossAdvicePage',
                    component: lossAdvicePage,
                    name: '出险管理',
                },
                {
                    path: '/auth/v1/property/promotionInfo/gotoPromotionPage',
                    component: VehiclePromotionInfoPage,
                    name: '活动购车补贴信息管理',
                },
                {
                    path: '/auth/v1/vehicle/buyInfo/gotoVehicleBuyInfoPage',
                    component: VehicleBuyInfoPage,
                    name: '活动购车信息管理',
                },
                {
                    path: '/auth/v1/vehicle/taxiInfo/gotoTaxiInfoPage',
                    component: TaxiInfoPage,
                    name: '出租车活动报名记录',
                },
                {
                    path: '/auth/v1/vehicle/changan/chananActivity2025',
                    component: chananActivity2025,
                    name: '长安汽车园购车节',
                },
                {
                    path: '/auth/v1/shop/customerclocknum/gotoShopCustomerClockNumPage',
                    component: ShopCustomerClockNumPage,
                    name: '园区活动打卡记录',
                },
                {
                    path: '/auth/v1/coupon/gotoOutCouponPage',
                    component: OutCouponPage,
                    name: '外部优惠券管理',
                },
                {
                    path: '/auth/v1/coupon/gotoCouponOrderPage',
                    component: CouponOrderPage,
                    name: '优惠券授权记录',
                },
                {
                    path: '/auth/v1/coupon/gotoOutCouponStatisticPage',
                    component: OutCouponStatisticPage,
                    name: '外部优惠券统计',
                },
                {
                    path: '/auth/v1/treasury/printerinfo/gotoTreasuryPrinterInfoPage',
                    component: TreasuryPrinterInfoPage,
                    name: '企业打印机管理',
                },
                {
                    path: '/auth/v1/treasury/printertemplate/gotoTreasuryPrinterTemplatePage',
                    component: TreasuryPrinterTemplatePage,
                    name: '打印模板管理',
                },
                {
                    path: '/auth/v1/treasury/printertemplate/gotoTreasuryPrinterLogPage',
                    component: TreasuryPrinterLogPage,
                    name: '打印日志管理',
                },
                {
                    path: '/auth/v1/treasury/printershop/gotoTreasuryPrinterShopPage',
                    component: TreasuryPrinterShopPage,
                    name: '打印设置管理',
                },
                {
                    path: '/auth/v1/tenement/gauge/statistic/gotoGaugeStatisticForDayPage',
                    component: GaugeStatisticForDayPage,
                    name: '微断供电按天统计',
                },
                {
                    path: '/auth/v1/tenement/gauge/statistic/gotoGaugeStatisticForMonthPage',
                    component: GaugeStatisticForMonthPage,
                    name: '微断供电按月统计',
                },
                {
                    path: '/auth/v1/tenement/gauge/statistic/gotoAllGaugeStatisticForMonthPage',
                    component: AllGaugeStatisticForMonthPage,
                    name: '微断供电月度统计',
                },
                {
                    path: '/auth/v1/coupon/customer/gotoVerifyCouponCustomerPage',
                    component: VerifyCouponCustomerPage,
                    name: '优惠券核销记录',
                },
                {
                    path: '/auth/v1/coupon/customer/gotoVerifyExternalCouponPage',
                    component: VerifyExternalCouponPage,
                    name: '外部优惠券核销记录',
                },
                {
                    path: '/auth/v1/motor/cooperation/gotoCooperationSuplierCompanyPage',
                    component: CooperationSuplierCompanyPage,
                    name: '合作公司',
                },
                {
                    path: '/auth/v1/motor/cooperation/gotoCooperationSuplierCustomerPage',
                    component: CooperationSuplierCustomerPage,
                    name: '合作个人',
                },
                {
                    path: '/auth/v1/motor/preparationItem/gotoPreparationItemPage',
                    component: MotorPreparationItemPage,
                    name: '整备项目分类',
                },
                {
                    path: '/motor/usedCarEvaluation/gotoUsedCarEvaluationPage',
                    component: usedCarEvaluationPage,
                    name: '二手车评估采购管理',
                },
                {
                    path: '/auth/v1/motor/usedCarSource/gotoUsedCarSourceZCPage',
                    component: UsedCarSourceZCPage,
                    name: '二手车车源自采管理',
                },
                {
                    path: '/motor/usedCarSource/gotoUsedCarSourcePage',
                    component: UsedCarSourcePage,
                    name: '二手车车源管理',
                },
                {
                    path: '/motor/usedCarSource/gotoUsedCarSourceInputPage',
                    component: UsedCarSourceInputPage,
                    name: '车源录入管理',
                },
                {
                    path: '/motor/usedCarSource/usedCarSourceReviewPage',
                    component: UsedCarSourceReviewPage,
                    name: '待复核车辆管理',
                },
                {
                    path: '/motor/usedCarSource/usedCarSourceReviewedPage',
                    component: UsedCarSourceReviewedPage,
                    name: '已复核车辆管理',
                },
                {
                    path: '/motor/usedCarSource/usedCarSourceReceivePage',
                    component: UsedCarSourceReceivePage,
                    name: '待接收车辆管理',
                },
                {
                    path: '/motor/usedCarSource/usedCarSourceReceivedPage',
                    component: UsedCarSourceReceivedPage,
                    name: '已接收车辆管理',
                },
                {
                    path: '/auth/v1/motor/usedcartransfer/gotoUsedCarTransferPage',
                    component: UsedCarTransferPage,
                    name: '二手车过户管理',
                },
                {
                    path: '/auth/v1/motor/usedCarPreparation/gotoUsedCarPreparationPage',
                    component: UsedCarPreparationPage,
                    name: '整备申请单管理',
                },
                {
                    path: '/auth/v1/motor/carCombo/gotoCarComboPage',
                    component: CarComboPage,
                    name: '车辆套餐管理',
                },
                {
                    path: '/auth/v1/motor/usedCarOrder/gotoUsedCarOrderPage',
                    component: UsedCarOrderPage,
                    name: '二手车订单管理',
                },
                {
                    path: '/auth/v1/motor/usedCarSource/gotoUsedCarRecheckPage',
                    component: UsedCarRecheckPage,
                    name: '复检项管理',
                },
                {
                    path: '/auth/v1/motor/usedCarSource/gotoUsedCarAccessoryClassifyPage',
                    component: UsedCarAccessoryClassifyPage,
                    name: '车辆图片分类管理',
                },
                {
                    path: '/auth/v1/motor/usedCarSource/gotoUsedCarAccessoryTypePage',
                    component: UsedCarAccessoryTypePage,
                    name: '车辆图片管理',
                },
                {
                    path: '/auth/v1/motor/usedCarSource/gotoUsedCarResultPage',
                    component: UsedCarResultPage,
                    name: '复检结果管理',
                },
                {
                    path: '/auth/v1/motor/usedCarSource/gotoUsedCarStorageOrderPage',
                    component: UsedCarStorageOrderPage,
                    name: '车辆交接单管理',
                },
                {
                    path: '/motor/vehicle/gotoMotorUsedVehiclePage',
                    component: MotorUsedVehiclePage,
                    name: '二手车库存管理',
                },
                {
                    path: '/motor/vehicle/gotoMotorUsedNewVehiclePage',
                    component: MotorUsedNewVehiclePage,
                    name: '车辆库存管理',
                },
                {
                    path: '/motor/usedCarInventory/usedVehicleMakePricePage',
                    component: usedVehicleMakePricePage,
                    name: '待定价车辆管理',
                },
                {
                    path: '/motor/usedCarInventory/usedVehiclePutShelvesPage',
                    component: usedVehiclePutShelvesPage,
                    name: '待上架车辆管理',
                },
                {
                    path: '/motor/usedCarInventory/usedVehicleNotSoldPage',
                    component: usedVehicleNotSoldPage,
                    name: '在售车辆管理',
                },
                {
                    path: '/motor/usedCarInventory/usedVehicleSoldPage',
                    component: usedVehicleSoldPage,
                    name: '已售车辆管理',
                },
                {
                    path: '/motor/usedCarInventory/usedVehicleBatchSoldPage',
                    component: usedVehicleBatchSoldPage,
                    name: '批售在售车辆',
                },
                {
                    path: '/motor/usedCarInventory/usedVehicleBatchSoldOutPage',
                    component: usedVehicleBatchSoldOutPage,
                    name: '批售已售车辆',
                },
                {
                    path: '/motor/usedCarInventory/usedVehicleDeliverPage',
                    component: usedVehicleDeliverPage,
                    name: '待交付车辆管理',
                },
                {
                    path: '/motor/vehicle/usedVehicleInHallPage',
                    component: usedVehicleInHallPage,
                    name: '在厅车辆',
                },
                // {
                //     path: '/motor/fineVehicleType/gotoMotorFineVehicleTypePage',
                //     component: MotorFineVehicleTypePage,
                //     name: '细分车型管理',
                // },
                {
                    path: '/auth/v1/motor/carSquareDevice/gotoCarSquareDevicePage',
                    component: CarSquareDevicePage,
                    name: '车场设备管理',
                },
                {
                    path: '/auth/v1/motor/carIdentify/gotoCarIdentifyPage',
                    component: CarIdentifyPage,
                    name: '车场RFID管理',
                },
                {
                    path: '/auth/v1/motor/vehicle/gotoMotorUsedCarStoreTrafficPage',
                    component: MotorUsedCarStoreTrafficPage,
                    name: '客流管理',
                },
                {
                    path: '/auth/v1/motor/vehicle/gotoVeclieInformationCostClassesParentPage',
                    component: VehicleInformationCostClassesParentPage,
                    name: '档案费用类别',
                },
                {
                    path: '/auth/v1/motor/vehicle/gotoVeclieClientManageSourcePage',
                    component: VehicleClientManageSourcePage,
                    name: '档案客户来源',
                },
                {
                    path: '/auth/v1/motor/vehicle/gotoVeclieInformationCostClassesPage',
                    component: VehicleInformationCostClassesPage,
                    name: '档案费用小分类',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationCostNotAuditPage',
                    component: VehicleInformationCostNotAuditPage,
                    name: '待审核收款通知单',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationCostAuditPage',
                    component: VehicleInformationCostAuditPage,
                    name: '已审核收款通知单',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationCostReceiptPage',
                    component: VehicleInformationCostReceiptPage,
                    name: '收款通知单管理',
                },
                {
                    path: '/auth/v1/vehicle/informationManage/gotoInformationCostStatisticsPage',
                    component: VehicleInformationCostStatisticsPage,
                    name: '费用统计',
                },
                {
                    path: '/auth/v1/vehicle/archivesContractType/gotoVehicleArchivesContractTypePage',
                    component: VehicleArchivesContractTypePage,
                    name: '企业合同类型设置',
                },
                {
                    path: '/auth/v1/vehicle/shopHall/gotoMotorShopHallPage',
                    component: MotorShopHallPage,
                    name: '企业厅位管理',
                },
                {
                    path: '/auth/v1/shop/ShopCustomerVisitsPage',
                    component: ShopCustomerVisitsPage,
                    name: '门店客流管理',
                },
                {
                    path: '/auth/v1/shop/BasicStructureGroupUserPage',
                    component: BasicStructureGroupUserPage,
                    name: '用户组管理',
                },
                {
                    path: '/auth/v1/motor/usedCar/preparationSupplier/gotoPreparationSupplierPage',
                    component: UsedCarPreparationSupplierPage,
                    name: '维修公司整备单',
                },
                {
                    path: '/auth/v1/motor/usedCar/task/gotoUsedCarTaskPage',
                    component: UsedCarTaskPage,
                    name: '任务管理',
                },
                {
                    path: '/auth/v1/shop/potentialStatistics/report',
                    component: potentialStatisticsReport,
                    name: '潜客统计',
                },
                {
                    path: '/auth/v1/shop/potentialStatistics/detail',
                    component: potentialStatisticsDetail,
                    name: '潜客统计详情',
                },
                {
                    path: '/auth/v1/shop/potentialStatistics/passengerDetail',
                    component: potentialPassengerDetail,
                    name: '客流统计详情',
                },
                {
                    path: '/auth/v1/motor/usedCarSourceDocumentType/gotoUsedCarDocumentTypePage',
                    component: usedCarDocumentType,
                    name: '二手车附件类型',
                },
                {
                    path: '/auth/v1/statistics/latentComeFromByMonthPage',
                    component: latentComeFromByMonth,
                    name: '客流来源月份统计',
                },
                {
                    path: '/auth/v1/statistics/yxLatentComeFromByMonthPage',
                    component: yxLatentComeFromByMonth,
                    name: '有效客流来源月份统计',
                },
                {
                    path: '/auth/v1/statistics/latentComeFromByDay',
                    component: latentComeFromByDay,
                    name: '客流来源日统计',
                },
                {
                    path: '/auth/v1/statistics/yxLatentComeFromByDay',
                    component: yxLatentComeFromByDay,
                    name: '有效客流来源日统计',
                },
                {
                    path: '/auth/v1/statistics/latentComeFromTypeByMonth',
                    component: latentComeFromTypeByMonth,
                    name: '汇总客流来源月份统计',
                },
                {
                    path: '/auth/v1/statistics/cjqd',
                    component: cjqdPage,
                    name: '成交渠道分析',
                },
                {
                    path: '/auth/v1/statistics/customerVisitsByDay',
                    component: customerVisitsByDayPage,
                    name: '客流每日统计',
                },
                {
                    path: '/auth/v1/statistics/customerVisitsByMonth',
                    component: customerVisitsByMonthPage,
                    name: '日均到店客流数量统计',
                },
                {
                    path: '/auth/v1/statistics/wdqktj',
                    component: wdqktjPage,
                    name: '网电客流统计',
                },
                {
                    path: '/auth/v1/motor/companyCustomerLevel/gotoCompanyCustomerLevelPage',
                    component: CompanyCustomerLevelPage,
                    name: '企业二级人员管理',
                },
                {
                    path: '/auth/v1/shop/companyLevelLatentCustomer/gotoCompanyLevelLatentCustomerPage',
                    component: CompanyLevelLatentCustomerPage,
                    name: '县域线索管理',
                },
                {
                    path: '/auth/v1/shop/latentrecord/getRecordListByPage',
                    component: InvitationRecordPage,
                    name: '店铺邀约记录',
                },
                {
                    path: '/auth/v1/statistics/cluesStatisticsPage',
                    component: cluesStatisticsPage,
                    name: '线索数量报表',
                },
                {
                    path: '/auth/v1/statistics/bykhfbtjPage',
                    component: bykhfbtjPage,
                    name: '保有客户分布统计',
                },
                {
                    path: '/auth/v1/statistics/ztjdPage',
                    component: ztjdPage,
                    name: '展厅接待统计',
                },
                {
                    path: '/auth/v1/statistics/xscxPage',
                    component: xscxPage,
                    name: '销售车型统计',
                },
                {
                    path: '/auth/v1/statistics/qkgjjlPage',
                    component: qkgjjlPage,
                    name: '潜客跟进记录统计',
                },
                {
                    path: '/auth/v1/statistics/ydlsPage',
                    component: ydlsPage,
                    name: '月度零售数据',
                },
                {
                    path: '/auth/v1/statistics/customerVisitStatisticsByDayPage',
                    component: customerVisitStatisticsByDayPage,
                    name: '展厅客流日统计',
                },
                {
                    path: '/auth/v1/statistics/customerVisitStatisticsByMonthPage',
                    component: customerVisitStatisticsByMonthPage,
                    name: '展厅客流月统计',
                },
                {
                    path: '/auth/v1/statistics/salesAdvisorVisitsByDayPage',
                    component: salesAdvisorVisitsByDayPage,
                    name: '线索统计',
                },
                {
                    path: '/auth/v1/statistics/latentAllocate/ShopLatentAllocatePage',
                    component: shopLatentAllocatePagePage,
                    name: '线索再分配',
                },
                {
                    path: '/auth/v1/statistics/progressOfCollectionAndSalesPage',
                    component: progressOfCollectionAndSalesPage,
                    name: '内勤-收销进度',
                },
                {
                    path: '/auth/v1/statistics/customersForVehicleSalesPage',
                    component: customersForVehicleSalesPage,
                    name: '内勤-销售车辆客户信息汇总',
                },
                {
                    path: '/auth/v1/statistics/acquisitionOfVehicleCustomerInformationPage',
                    component: acquisitionOfVehicleCustomerInformationPage,
                    name: '内勤-收购车辆客户信息汇总',
                },
                {
                    path: '/auth/v1/statistics/salesOrderStatisticsPage',
                    component: salesOrderStatisticsPage,
                    name: '内勤-进销存',
                },
                {
                    path: '/auth/v1/statistics/purchaseSaleStockDailyPage',
                    component: purchaseSaleStockDailyPage,
                    name: '内勤-进销存日报',
                },
                {
                    path: '/auth/v1/statistics/usedCarDailyPage',
                    component: usedCarDailyPage,
                    name: '内勤-申联二手车日报',
                },
                {
                    path: '/auth/v1/statistics/dailySalesDetailsPage',
                    component: dailySalesDetailsPage,
                    name: '进销存日报-每日销售明细',
                },
                {
                    path: '/auth/v1/statistics/dailyPurchaseDetailsPage',
                    component: dailyPurchaseDetailsPage,
                    name: '进销存日报-每日收购明细',
                },
                {
                    path: '/auth/v1/statistics/usedCarSaleReportPage',
                    component: usedCarSaleReportPage,
                    name: '内勤-申联二手车销售战报',
                },
                {
                    path: '/auth/v1/statistics/customerVisitsSuccessPage',
                    component: customerVisitsSuccessPage,
                    name: '成交漏斗统计',
                },
                {
                    path: '/auth/v1/statistics/customerVisitsContrastPage',
                    component: customerVisitsContrastPage,
                    name: '月份客流统计-客流对比',
                },
                {
                    path: '/auth/v1/vehicle/informationFileType/VehicleInformationFileTypePage',
                    component: VehicleInformationFileTypePage,
                    name: '附件管理',
                },
                {
                    path: '/auth/v1/basic/userLoginRecord/UserLoginRecordPage',
                    component: UserLoginRecordPage,
                    name: '用户登录日志',
                },
                {
                    path: '/auth/v1/vehicle/informationCostpayType/InformationCostpayTypePage',
                    component: InformationCostpayTypePage,
                    name: '收款方式管理',
                },
                {
                    path: '/auth/v1/basic/supplyChainManagement/SupplyChainManagementPage',
                    component: SupplyChainManagementPage,
                    name: '供应链管理',
                },
                {
                    path: '/auth/v1/receipt/SaveReceiptPage',
                    component: SaveReceiptPage,
                    name: '收款页',
                },
                {
                    path: '/faq',
                    component: FaqPage,
                    name: '常见问题',
                }
            ],
        },
        // 用于登录后404页面，登录前已在全局路由拦截器处理
        {path: '*', redirect: '/error'},
    ],
})

// 解决重复导航到当前路由的错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}
